var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyEvents(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 249.034,
    height: 168.663,
    viewBox: "0 0 249.034 168.663",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration_",
    "data-name": "Illustration ",
    transform: "translate(-42.61 -70.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-11",
    transform: "translate(42.61 233.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509843",
    "data-name": "Path 509843",
    d: "M291.643,461.663c0,.071-55.753.123-124.509.123s-124.524-.029-124.524-.123,55.738-.124,124.524-.124S291.643,461.6,291.643,461.663Z",
    transform: "translate(-42.61 -461.54)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-11",
    transform: "translate(71.621 70.18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204001",
    "data-name": "Rectangle 204001",
    width: 34.1,
    height: 42.654,
    transform: "translate(0.118 34.157) rotate(-82.33)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509844",
    "data-name": "Path 509844",
    d: "M156.8,76.55l-.209-.024-.6-.071-2.3-.3-8.658-1.135L114.51,70.965l.123-.095c-1.349,10.059-2.9,21.6-4.54,33.8h0l-.1-.142,42.269,5.7-.114.09L155.5,85.807c.408-2.949.731-5.262.95-6.844q.161-1.183.256-1.809c.057-.408.095-.622.095-.622a3.941,3.941,0,0,1-.071.608l-.223,1.819c-.209,1.582-.508,3.89-.893,6.834-.784,5.913-1.9,14.376-3.258,24.582v.1h-.1L109.983,104.8h-.123v-.123h0l4.564-33.791V70.78h.109l30.586,4.175,8.639,1.154,2.27.318.579.085Z",
    transform: "translate(-109.86 -70.495)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204002",
    "data-name": "Rectangle 204002",
    width: 29.807,
    height: 39.657,
    transform: "translate(1.864 32.229) rotate(-82.33)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509845",
    "data-name": "Path 509845",
    d: "M113.78,119.773l16.2-16.513,6.958,12.638,6.592-5.367,9.551,14.538Z",
    transform: "translate(-111.918 -87.549)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509846",
    "data-name": "Path 509846",
    d: "M167.131,98.089a3.116,3.116,0,1,1-.61-2.311A3.12,3.12,0,0,1,167.131,98.089Z",
    transform: "translate(-136.669 -82.977)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633180",
    "data-name": "Group 633180",
    transform: "translate(1.862 15.711)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509847",
    "data-name": "Path 509847",
    d: "M113.78,119.773l16.2-16.513,6.958,12.638,6.592-5.367,9.551,14.538Z",
    transform: "translate(-113.78 -103.26)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_633181",
    "data-name": "Group 633181",
    transform: "translate(24.249 11.575)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509848",
    "data-name": "Path 509848",
    d: "M167.131,98.089a3.116,3.116,0,1,1-.61-2.311A3.12,3.12,0,0,1,167.131,98.089Z",
    transform: "translate(-160.918 -94.551)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204003",
    "data-name": "Rectangle 204003",
    width: 174.495,
    height: 114.25,
    transform: "translate(41.091 0.142)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509849",
    "data-name": "Path 509849",
    d: "M372.01,87.263c0,.066-39.068.123-87.25.123s-87.25-.057-87.25-.123,39.058-.123,87.25-.123S372.01,87.2,372.01,87.263Z",
    transform: "translate(-155.882 -79.085)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509850",
    "data-name": "Path 509850",
    d: "M207.184,78.442a1,1,0,1,1-.292-.71,1,1,0,0,1,.292.71Z",
    transform: "translate(-159.909 -73.992)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509851",
    "data-name": "Path 509851",
    d: "M214.784,78.442a1,1,0,1,1-.292-.71A1,1,0,0,1,214.784,78.442Z",
    transform: "translate(-163.9 -73.992)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509852",
    "data-name": "Path 509852",
    d: "M222.4,78.442a1,1,0,1,1-.29-.708,1,1,0,0,1,.29.708Z",
    transform: "translate(-167.901 -73.992)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204004",
    "data-name": "Rectangle 204004",
    width: 59.552,
    height: 3.287,
    transform: "translate(99.346 14.234)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509853",
    "data-name": "Path 509853",
    d: "M371.267,202.028c0-.746-.033-31.877-.09-82.895l.09.09-156.452.033h0l.128-.123v82.895l-.119-.119,156.466.119-156.466.114h-.114V119h.138l156.452.028h.1v.1C371.3,170.15,371.271,201.282,371.267,202.028Z",
    transform: "translate(-164.913 -95.814)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509854",
    "data-name": "Path 509854",
    d: "M255.4,201.82c-.071,0-.071-18.556,0-41.443s.176-41.447.242-41.447.071,18.556,0,41.447S255.467,201.82,255.4,201.82Z",
    transform: "translate(-186.251 -95.777)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509855",
    "data-name": "Path 509855",
    d: "M304.275,201.96c-.066,0-.066-18.556,0-41.443s.176-41.447.242-41.447.071,18.556,0,41.447S304.346,201.96,304.275,201.96Z",
    transform: "translate(-211.915 -95.851)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509856",
    "data-name": "Path 509856",
    d: "M353.151,202.1c-.071,0-.071-18.56,0-41.447s.176-41.447.242-41.447.071,18.556,0,41.447S353.217,202.1,353.151,202.1Z",
    transform: "translate(-237.576 -95.924)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509857",
    "data-name": "Path 509857",
    d: "M402.025,202.245c-.066,0-.066-18.56,0-41.447s.176-41.447.242-41.447.071,18.556,0,41.452S402.1,202.245,402.025,202.245Z",
    transform: "translate(-263.24 -95.998)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509858",
    "data-name": "Path 509858",
    d: "M450.941,202.36c-.071,0-.071-18.556,0-41.443s.176-41.447.242-41.447.071,18.551,0,41.447S450.988,202.36,450.941,202.36Z",
    transform: "translate(-288.922 -96.061)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509859",
    "data-name": "Path 509859",
    d: "M499.775,202.53c-.066,0-.066-18.556,0-41.443s.176-41.447.242-41.447.071,18.551,0,41.447S499.856,202.53,499.775,202.53Z",
    transform: "translate(-314.565 -96.15)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509860",
    "data-name": "Path 509860",
    d: "M371.571,161.343c0,.066-34.984.124-78.136.124s-78.145-.057-78.145-.124,34.984-.123,78.145-.123S371.571,161.272,371.571,161.343Z",
    transform: "translate(-165.218 -117.982)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509861",
    "data-name": "Path 509861",
    d: "M371.571,206.063c0,.066-34.984.123-78.136.123s-78.145-.057-78.145-.123,34.984-.123,78.145-.123S371.571,205.992,371.571,206.063Z",
    transform: "translate(-165.218 -141.463)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509862",
    "data-name": "Path 509862",
    d: "M371.571,250.773c0,.071-34.984.123-78.136.123s-78.145-.052-78.145-.123,34.984-.124,78.145-.124S371.571,250.707,371.571,250.773Z",
    transform: "translate(-165.218 -164.939)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509863",
    "data-name": "Path 509863",
    d: "M217.324,254.89s-1.852,12.025.076,19.52l18.522-.674s-3.8-11.964-1.392-17.943Z",
    transform: "translate(-165.865 -167.165)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509864",
    "data-name": "Path 509864",
    d: "M218.37,254s.123,14.775.874,19.282l18.522-.879s-1.629-14.523-1-18.4Z",
    transform: "translate(-166.835 -166.698)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509865",
    "data-name": "Path 509865",
    d: "M237.494,266.984c0,.071-2.778.294-6.212.5s-6.217.318-6.222.252,2.774-.29,6.207-.5S237.489,266.932,237.494,266.984Z",
    transform: "translate(-170.348 -173.508)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509866",
    "data-name": "Path 509866",
    d: "M237.5,273.6c0,.071-2.778.294-6.212.5s-6.217.318-6.222.252,2.774-.29,6.207-.5S237.5,273.532,237.5,273.6Z",
    transform: "translate(-170.353 -176.978)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509867",
    "data-name": "Path 509867",
    d: "M236.786,280.043a4.468,4.468,0,0,1-1.035.152c-.636.062-1.525.128-2.5.185s-1.862.1-2.5.114a4.276,4.276,0,0,1-1.045-.024,4.444,4.444,0,0,1,1.031-.152c.641-.057,1.525-.123,2.5-.185s1.867-.1,2.508-.114a4.674,4.674,0,0,1,1.045.024Z",
    transform: "translate(-172.784 -180.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509868",
    "data-name": "Path 509868",
    d: "M306.851,123.66s-1.52,12.514.408,20.009l18.2-.95s-3.8-12.2-1.425-18.18Z",
    transform: "translate(-212.995 -98.261)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509869",
    "data-name": "Path 509869",
    d: "M307.64,122.73s.124,14.775.874,19.282l18.522-.879s-1.629-14.523-1-18.4Z",
    transform: "translate(-213.708 -97.772)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509870",
    "data-name": "Path 509870",
    d: "M326.764,135.778c0,.066-2.778.29-6.207.475s-6.222.318-6.226.247,2.774-.29,6.207-.475S326.759,135.707,326.764,135.778Z",
    transform: "translate(-217.221 -104.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509871",
    "data-name": "Path 509871",
    d: "M326.774,142.363c0,.066-2.774.29-6.207.475s-6.222.323-6.226.252,2.774-.29,6.212-.5S326.769,142.292,326.774,142.363Z",
    transform: "translate(-217.226 -108.069)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509872",
    "data-name": "Path 509872",
    d: "M326.056,148.806a4.646,4.646,0,0,1-1.031.147c-.641.062-1.525.128-2.5.185s-1.866.1-2.508.119a4.17,4.17,0,0,1-1.045-.028,4.661,4.661,0,0,1,1.035-.147c.636-.062,1.525-.128,2.5-.185s1.862-.1,2.5-.119a4.146,4.146,0,0,1,1.045.029Z",
    transform: "translate(-219.657 -111.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509873",
    "data-name": "Path 509873",
    d: "M358.227,253.15s-1.5,13.683.427,21.177l18.285-.8s-3.918-13.5-1.51-19.472Z",
    transform: "translate(-239.979 -166.252)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509874",
    "data-name": "Path 509874",
    d: "M359,252.22s.123,14.775.874,19.282l18.522-.879s-1.629-14.523-1-18.4Z",
    transform: "translate(-240.675 -165.763)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509875",
    "data-name": "Path 509875",
    d: "M378.124,265.263c0,.066-2.778.29-6.207.475s-6.222.323-6.226.252,2.774-.29,6.207-.5S378.119,265.192,378.124,265.263Z",
    transform: "translate(-244.188 -172.599)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509876",
    "data-name": "Path 509876",
    d: "M378.134,271.853c0,.066-2.778.29-6.207.475s-6.222.318-6.226.252,2.774-.29,6.207-.5S378.129,271.782,378.134,271.853Z",
    transform: "translate(-244.193 -176.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509877",
    "data-name": "Path 509877",
    d: "M377.416,278.3a4.661,4.661,0,0,1-1.035.147c-.636.062-1.52.128-2.5.185s-1.867.1-2.508.119a4.443,4.443,0,0,1-1.045-.029,4.644,4.644,0,0,1,1.031-.147c.641-.062,1.525-.128,2.5-.19s1.866-.095,2.508-.114A4.146,4.146,0,0,1,377.416,278.3Z",
    transform: "translate(-246.624 -179.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509878",
    "data-name": "Path 509878",
    d: "M504.954,165.48s-1.9,11.75.024,19.24l18.565-.4s-3.8-11.964-1.391-17.943Z",
    transform: "translate(-316.872 -120.219)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509879",
    "data-name": "Path 509879",
    d: "M506,164.56s.123,14.77.874,19.277l18.522-.874s-1.629-14.523-1-18.4Z",
    transform: "translate(-317.86 -119.736)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509880",
    "data-name": "Path 509880",
    d: "M525.154,177.6c0,.071-2.774.29-6.207.475s-6.222.318-6.226.252,2.774-.294,6.212-.475S525.149,177.535,525.154,177.6Z",
    transform: "translate(-321.389 -126.574)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509881",
    "data-name": "Path 509881",
    d: "M525.164,184.191c0,.066-2.774.29-6.207.475s-6.222.318-6.226.252,2.778-.294,6.212-.475S525.159,184.125,525.164,184.191Z",
    transform: "translate(-321.394 -130.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509882",
    "data-name": "Path 509882",
    d: "M524.446,190.645a4.385,4.385,0,0,1-1.031.152c-.641.057-1.525.123-2.5.185s-1.867.1-2.508.114a4.675,4.675,0,0,1-1.045,0,4.463,4.463,0,0,1,1.035-.152c.636-.062,1.525-.128,2.5-.185s1.862-.1,2.508-.114A4.273,4.273,0,0,1,524.446,190.645Z",
    transform: "translate(-323.825 -133.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509883",
    "data-name": "Path 509883",
    d: "M405.914,210.81s-1.9,11.75.024,19.244l18.565-.4s-3.8-11.964-1.392-17.948Z",
    transform: "translate(-264.869 -144.02)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509884",
    "data-name": "Path 509884",
    d: "M407,209.89s.123,14.775.874,19.282l18.522-.879s-1.629-14.523-1-18.4Z",
    transform: "translate(-265.879 -143.537)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509885",
    "data-name": "Path 509885",
    d: "M426.114,222.968c0,.071-2.774.294-6.207.5s-6.222.318-6.226.252,2.774-.29,6.212-.5S426.109,222.878,426.114,222.968Z",
    transform: "translate(-269.386 -150.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509886",
    "data-name": "Path 509886",
    d: "M426.124,229.519c0,.071-2.774.294-6.207.5s-6.222.318-6.226.252,2.778-.29,6.212-.5S426.119,229.452,426.124,229.519Z",
    transform: "translate(-269.391 -153.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509887",
    "data-name": "Path 509887",
    d: "M425.406,235.953a4.452,4.452,0,0,1-1.031.152c-.641.062-1.525.128-2.5.185s-1.866.1-2.508.114a4.345,4.345,0,0,1-1.045-.024,4.464,4.464,0,0,1,1.035-.152c.636-.057,1.525-.128,2.5-.185s1.862-.1,2.5-.114a4.622,4.622,0,0,1,1.045.024Z",
    transform: "translate(-271.822 -157.199)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509888",
    "data-name": "Path 509888",
    d: "M480.865,170.57l-9.836,5.063-4.759-.674,2.546-4.512,10.377-3.657Z",
    transform: "translate(-296.999 -120.907)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509889",
    "data-name": "Path 509889",
    d: "M465.41,173.461l2.413-3.88,10.657-3.871,2.142,4.213-10.335,4.127Z",
    transform: "translate(-296.548 -120.34)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509890",
    "data-name": "Path 509890",
    d: "M482.457,170.99a5.991,5.991,0,0,1-1.035.475c-.646.266-1.544.617-2.541,1l-2.56.95c-.651.237-1.083.38-1.054.366a17.835,17.835,0,0,1,3.524-1.553A23.5,23.5,0,0,1,482.457,170.99Z",
    transform: "translate(-301.722 -123.108)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509891",
    "data-name": "Path 509891",
    d: "M481.649,175a14.791,14.791,0,0,1-4.749,1.767,21.33,21.33,0,0,1,2.375-.912A21.593,21.593,0,0,1,481.649,175Z",
    transform: "translate(-302.581 -125.218)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509892",
    "data-name": "Path 509892",
    d: "M217.658,164.06s-1.71,16.547.565,20.014l17.183-1.045-.912-18.38Z",
    transform: "translate(-166.138 -119.473)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509893",
    "data-name": "Path 509893",
    d: "M218.34,164.06s.119,14.4.855,18.784l18.047-.855s-1.586-14.148-.974-17.929Z",
    transform: "translate(-166.819 -119.473)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509894",
    "data-name": "Path 509894",
    d: "M232.605,168.345h.261a4.153,4.153,0,0,1,.75.038,4.1,4.1,0,0,1,1.149.337,3.852,3.852,0,0,1,1.249.988,4.4,4.4,0,0,1,.864,1.738,4.227,4.227,0,0,1-.19,2.232,6.692,6.692,0,0,1-.508,1.116,11.4,11.4,0,0,0-.579,1.126,9.773,9.773,0,0,0-.727,2.56v.062h-.057l-1.781.029-1.871.028H231.1v-.066a5.314,5.314,0,0,0-.864-2.465c-.218-.37-.475-.717-.674-1.069a9.77,9.77,0,0,1-.636-1.035,3.457,3.457,0,0,1-.28-2.2,4.7,4.7,0,0,1,.693-1.8,3.443,3.443,0,0,1,1.178-1.059,4.347,4.347,0,0,1,1.107-.427,4.963,4.963,0,0,1,.736-.123h0a4.624,4.624,0,0,0-.727.142,4.394,4.394,0,0,0-1.088.442,3.434,3.434,0,0,0-1.135,1.045,4.612,4.612,0,0,0-.665,1.767,3.372,3.372,0,0,0,.285,2.128,9.92,9.92,0,0,0,.632,1.021c.218.347.475.693.679,1.069a5.4,5.4,0,0,1,.893,2.531l-.066-.066,1.866-.033,1.781-.024-.062.057a9.56,9.56,0,0,1,.741-2.6,12.11,12.11,0,0,1,.589-1.135,6.619,6.619,0,0,0,.5-1.092,4.113,4.113,0,0,0,.2-2.17,4.34,4.34,0,0,0-.831-1.7,3.8,3.8,0,0,0-1.211-.978,4.15,4.15,0,0,0-1.126-.356,4.528,4.528,0,0,0-.741-.062h-.261Z",
    transform: "translate(-172.194 -121.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509895",
    "data-name": "Path 509895",
    d: "M235.592,182.137v-.223l-.1-.646c-.081-.56-.2-1.373-.28-2.375,0-.256-.038-.518-.048-.793a7.5,7.5,0,0,1,0-.864,2.347,2.347,0,0,1,.2-.9,1.373,1.373,0,0,1,.689-.689.921.921,0,0,1,.983.185.693.693,0,0,1,.214.475.893.893,0,0,1-.185.518,1.216,1.216,0,0,1-.437.351,2.089,2.089,0,0,1-.537.176,5.982,5.982,0,0,1-1.135.133,6.591,6.591,0,0,1-1.149-.052,2.155,2.155,0,0,1-.541-.161,1.424,1.424,0,0,1-.475-.323.992.992,0,0,1-.261-.475.831.831,0,0,1,.062-.537.75.75,0,0,1,.38-.366.622.622,0,0,1,.513,0,.983.983,0,0,1,.385.323,1.344,1.344,0,0,1,.19.475,5.221,5.221,0,0,1,.09.921c.033.594.062,1.149.09,1.653.048,1.012.09,1.829.119,2.375a4.07,4.07,0,0,0,.028.651v.228a.538.538,0,0,1,0-.057v-.171c0-.152-.024-.37-.043-.651-.033-.565-.081-1.382-.138-2.375-.029-.508-.057-1.059-.09-1.653a6,6,0,0,0-.1-.912,1.3,1.3,0,0,0-.185-.432.874.874,0,0,0-.361-.309.594.594,0,0,0-.475-.024.674.674,0,0,0-.347.342.755.755,0,0,0-.062.5.95.95,0,0,0,.252.475,1.6,1.6,0,0,0,.95.475,6.433,6.433,0,0,0,1.135.052,6.338,6.338,0,0,0,1.13-.128,2.414,2.414,0,0,0,.522-.176,1.15,1.15,0,0,0,.418-.332.836.836,0,0,0,.171-.475.617.617,0,0,0-.195-.475.86.86,0,0,0-.926-.176,1.316,1.316,0,0,0-.66.66,2.374,2.374,0,0,0-.2.883v.86a4.792,4.792,0,0,0,.043.793c.076,1.007.19,1.819.261,2.375.038.28.071.475.09.646l.024.171A.528.528,0,0,1,235.592,182.137Z",
    transform: "translate(-174.259 -125.487)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509896",
    "data-name": "Path 509896",
    d: "M234,189.539s.024.223.047.6.052.95.081,1.563v-.038l1.216,1.425-.062-.024,1.425-.081-.062.028.7-.855.351-.423v.052c0-.822-.033-1.6-.052-2.313l.076.071-2.622.029h-.76a2.085,2.085,0,0,1-.285,0,1.321,1.321,0,0,1,.252,0l.741-.038,2.669-.1h.076v.076c0,.712.043,1.491.066,2.313v.033h-.024c-.114.138-.233.28-.347.427-.242.29-.475.575-.7.85l-.024.028h-.038l-1.425.066h-.038V193.2l-1.192-1.425h0v-1.624A4.576,4.576,0,0,1,234,189.539Z",
    transform: "translate(-175.042 -132.794)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509897",
    "data-name": "Path 509897",
    d: "M237.765,193.44a.727.727,0,0,1-.133-.057c-.085-.038-.209-.09-.366-.142a3.629,3.629,0,0,0-1.268-.195,3.567,3.567,0,0,0-1.254.271,3.383,3.383,0,0,0-.356.166l-.128.062a.58.58,0,0,1,.119-.081,2.651,2.651,0,0,1,.347-.185,3.381,3.381,0,0,1,1.273-.29,3.433,3.433,0,0,1,1.282.214,2.851,2.851,0,0,1,.361.161A.559.559,0,0,1,237.765,193.44Z",
    transform: "translate(-175.178 -134.662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509898",
    "data-name": "Path 509898",
    d: "M237.765,192.259l-.133-.057c-.085-.038-.209-.09-.366-.147a3.638,3.638,0,0,0-1.268-.19,3.566,3.566,0,0,0-1.254.271,2.627,2.627,0,0,0-.356.166.657.657,0,0,1-.128.062.856.856,0,0,1,.119-.081,2.175,2.175,0,0,1,.347-.185,3.367,3.367,0,0,1,2.555-.076,2.513,2.513,0,0,1,.361.161A.56.56,0,0,1,237.765,192.259Z",
    transform: "translate(-175.178 -134.042)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509899",
    "data-name": "Path 509899",
    d: "M237.7,191.129a.73.73,0,0,1-.133-.057c-.085-.038-.209-.09-.366-.142a3.628,3.628,0,0,0-1.268-.195,3.566,3.566,0,0,0-1.254.271,3.386,3.386,0,0,0-.356.166l-.128.067a.639.639,0,0,1,.119-.086,3.275,3.275,0,0,1,2.9-.261,3.186,3.186,0,0,1,.361.161A.56.56,0,0,1,237.7,191.129Z",
    transform: "translate(-175.142 -133.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509900",
    "data-name": "Path 509900",
    d: "M310.6,247.239c.024,0,0,.223-.233.475a2.935,2.935,0,0,1-1.04.717,3.077,3.077,0,0,1-1.729.318c0-.076.765-.171,1.629-.546a3.609,3.609,0,0,0,1.012-.613C310.469,247.391,310.564,247.225,310.6,247.239Z",
    transform: "translate(-213.687 -163.148)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509901",
    "data-name": "Path 509901",
    d: "M371.915,184.553c0-.8-.038-44.539-.1-114.25l.1.1H197.434l.123-.123v114.25l-.114-.114,174.495.114-174.495.114h-.114V70.18H372.043v.1C371.948,140.019,371.915,183.755,371.915,184.553Z",
    transform: "translate(-155.788 -70.18)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509902",
    "data-name": "Path 509902",
    d: "M474.61,268.451l-3.429-5.851-3.253,5.851H421.76v24.136h71.891V268.451Z",
    transform: "translate(-273.629 -171.213)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509903",
    "data-name": "Path 509903",
    d: "M440.866,293.445A3.534,3.534,0,0,0,443,290.187a3.325,3.325,0,0,0-6.649-.086,3.538,3.538,0,0,0,2.085,3.325c-5.115.727-4.93,6.3-4.93,6.3l12.082.157S445.914,294.257,440.866,293.445Z",
    transform: "translate(-279.797 -183.93)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509904",
    "data-name": "Path 509904",
    d: "M510.547,289.863c0,.071-9.176.124-20.493.124s-20.493-.052-20.493-.124,9.176-.124,20.493-.124S510.547,289.787,510.547,289.863Z",
    transform: "translate(-298.727 -185.464)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509905",
    "data-name": "Path 509905",
    d: "M510.547,297.593c0,.067-9.176.124-20.493.124s-20.493-.057-20.493-.124,9.176-.123,20.493-.123S510.547,297.527,510.547,297.593Z",
    transform: "translate(-298.727 -189.523)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509906",
    "data-name": "Path 509906",
    d: "M510.547,305.344c0,.066-9.176.124-20.493.124s-20.493-.057-20.493-.124,9.176-.124,20.493-.124S510.547,305.277,510.547,305.344Z",
    transform: "translate(-298.727 -193.592)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509907",
    "data-name": "Path 509907",
    d: "M490.053,313.013c0,.067-4.588.124-10.244.124s-10.249-.057-10.249-.124,4.588-.123,10.249-.123S490.053,312.942,490.053,313.013Z",
    transform: "translate(-298.727 -197.619)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-11",
    transform: "translate(170.977 91.822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509908",
    "data-name": "Path 509908",
    d: "M558.359,170.834a2.22,2.22,0,0,1-.5-2.028c-.513-.271-.556-.722-.556-1.3a3.49,3.49,0,0,1,.5-1.639,4.774,4.774,0,0,1,1.847-2.028,2.47,2.47,0,0,1,2.631.114,3.191,3.191,0,0,1,4.569-.318,3.659,3.659,0,0,0,.7.632,3.875,3.875,0,0,0,1.534.2,2.693,2.693,0,0,1,2.227,3.742,2.9,2.9,0,0,1,1.24,2.232,8.581,8.581,0,0,1-.3,2.617,6.045,6.045,0,0,1-1.254,2.959,3.092,3.092,0,0,1-1.971.95,3.135,3.135,0,0,1-2.759-1.3",
    transform: "translate(-507.917 -162.824)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509909",
    "data-name": "Path 509909",
    d: "M570.584,193.305l-8.511-.389c-.047-.9.413-6.492.413-6.492a3.832,3.832,0,0,1-3.258-3.719c-.038-3.244.518-10.605.518-10.605h0a11.18,11.18,0,0,1,11.237,1.425l.475.366Z",
    transform: "translate(-508.928 -167.219)",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509910",
    "data-name": "Path 509910",
    d: "M566.069,201.842a7.471,7.471,0,0,0,4.194-1.192,3.966,3.966,0,0,1-4.2,2.028Z",
    transform: "translate(-512.516 -182.685)",
    fill: "#aa6550"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509911",
    "data-name": "Path 509911",
    d: "M584,183.757c.057-.024,2.213-.655,2.142,1.544a1.652,1.652,0,0,1-2.265,1.61C583.88,186.844,584,183.757,584,183.757Z",
    transform: "translate(-521.873 -173.762)",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509912",
    "data-name": "Path 509912",
    d: "M585.349,186.874s.038.024.1.057a.366.366,0,0,0,.29,0,.95.95,0,0,0,.475-.836,1.3,1.3,0,0,0-.081-.556.442.442,0,0,0-.28-.3.2.2,0,0,0-.228.1c-.033.057,0,.1-.033.1s-.043-.038-.024-.128a.233.233,0,0,1,.09-.133.3.3,0,0,1,.214-.052.541.541,0,0,1,.389.356,1.305,1.305,0,0,1,.114.617.993.993,0,0,1-.589.95.4.4,0,0,1-.347-.067C585.354,186.927,585.344,186.874,585.349,186.874Z",
    transform: "translate(-522.643 -174.533)",
    fill: "#aa6550"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509913",
    "data-name": "Path 509913",
    d: "M561.81,183.257a.475.475,0,0,0,.442.475.447.447,0,0,0,.475-.418.475.475,0,0,0-.442-.475.442.442,0,0,0-.475.418Z",
    transform: "translate(-510.285 -173.333)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509914",
    "data-name": "Path 509914",
    d: "M561.592,182.094c.057.062.4-.195.9-.195s.86.247.912.185-.033-.133-.19-.247a1.268,1.268,0,0,0-.727-.228,1.244,1.244,0,0,0-.717.233C561.615,181.961,561.563,182.066,561.592,182.094Z",
    transform: "translate(-510.166 -172.688)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509915",
    "data-name": "Path 509915",
    d: "M572,183.541a.475.475,0,0,0,.442.475.442.442,0,0,0,.475-.413.475.475,0,0,0-.446-.475.432.432,0,0,0-.47.413Z",
    transform: "translate(-515.635 -173.484)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509916",
    "data-name": "Path 509916",
    d: "M571.822,182.294c.057.057.408-.2.9-.2s.855.252.907.19-.029-.138-.19-.252a1.259,1.259,0,0,0-.727-.223,1.192,1.192,0,0,0-.717.233C571.846,182.157,571.793,182.266,571.822,182.294Z",
    transform: "translate(-515.538 -172.793)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509917",
    "data-name": "Path 509917",
    d: "M566.67,186a3.283,3.283,0,0,0-.8-.147c-.124,0-.242-.038-.266-.123a.654.654,0,0,1,.085-.375c.119-.3.242-.627.375-.95a16.019,16.019,0,0,0,.836-2.517,16.919,16.919,0,0,0-1.04,2.441l-.356.95a.74.74,0,0,0-.066.475.309.309,0,0,0,.209.185.736.736,0,0,0,.214.029A3.2,3.2,0,0,0,566.67,186Z",
    transform: "translate(-512.181 -172.835)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509918",
    "data-name": "Path 509918",
    d: "M569.377,191.27c-.081,0-.081.532-.541.912s-1.031.323-1.035.394.128.1.37.114a1.367,1.367,0,0,0,.864-.3,1.154,1.154,0,0,0,.418-.765C569.472,191.4,569.415,191.265,569.377,191.27Z",
    transform: "translate(-513.43 -177.76)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509919",
    "data-name": "Path 509919",
    d: "M571.558,178.342c.052.133.546.066,1.125.138s1.05.228,1.126.109-.047-.185-.237-.313a1.814,1.814,0,0,0-.855-.29,1.9,1.9,0,0,0-.879.1C571.648,178.171,571.539,178.275,571.558,178.342Z",
    transform: "translate(-515.402 -170.778)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509920",
    "data-name": "Path 509920",
    d: "M561.981,179.062c.09.109.427,0,.841,0s.755.076.836-.043,0-.171-.171-.275a1.173,1.173,0,0,0-.684-.185,1.13,1.13,0,0,0-.665.228C561.981,178.891,561.933,179.005,561.981,179.062Z",
    transform: "translate(-510.365 -171.085)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509921",
    "data-name": "Path 509921",
    d: "M571.019,172.395a22.754,22.754,0,0,1,0,2.9c-.029.138-.389.513-.418.651-.19.812-.527,1.164-1.012.323a7.16,7.16,0,0,1-.38-1.586l-.584-2.973a5.154,5.154,0,0,1-2.446.579,2.5,2.5,0,0,1-2.09-1.235,2.6,2.6,0,0,1-4.027.532,1.087,1.087,0,0,1-1.425.3,1.287,1.287,0,0,1-.522-1.425,2.433,2.433,0,0,1,1.847-1.425,11.828,11.828,0,0,1,9.19,1.425,4.466,4.466,0,0,1,1.111.836c.313.342.75.746.765,1.211",
    transform: "translate(-508.318 -165.881)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509922",
    "data-name": "Path 509922",
    d: "M539.075,224.926l3.282-8.943a8.532,8.532,0,0,0-6.554-5.438,21.353,21.353,0,0,0-3.415-.655h0a6.716,6.716,0,0,1-8.2.1l-.119-.085c-.328.038-.765.081-1.311.147h-.109a8.046,8.046,0,0,0-3.766,1.5h0l-17.131,10.225L491.7,214.131l-5.1,3.994s13.179,13.179,14.457,13.493c.888.218,9.679-4.583,15.008-7.556-.219,3.192-1.425,20.93-1.354,23.352h24.478V233.185Z",
    transform: "translate(-470.794 -187.537)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509923",
    "data-name": "Path 509923",
    d: "M577,241.694s11.921,5.258,13.061,5.5c3.8.831,7.262-2.341,6.706-5.329-.285-1.553-7-20-7-20l-4.825,7.186,2.4,9.385-7.257-.926Z",
    transform: "translate(-518.26 -193.827)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509924",
    "data-name": "Path 509924",
    d: "M587.511,263.53a.836.836,0,0,0-.19-.1l-.57-.28-2.142-1-7.295-3.324.047.147,1.4-2.5c.3-.532.594-1.059.869-1.558l-.1.057,8.724.855,2.593.233.7.052a.953.953,0,0,0,.242,0,1,1,0,0,0-.237-.043l-.7-.09-2.588-.3-8.72-.95h-.066l-.038.062c-.276.5-.57,1.021-.869,1.558-.475.855-.95,1.691-1.392,2.5l-.057.1.1.047,7.328,3.263,2.166.95.584.242A.865.865,0,0,0,587.511,263.53Z",
    transform: "translate(-518.323 -211.081)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509925",
    "data-name": "Path 509925",
    d: "M569.831,248.56l1.021-4.973s-12.571-.161-12.434.062,1.33,11.4,1.33,11.4,8.843-.332,8.515-.3Z",
    transform: "translate(-508.503 -205.201)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509926",
    "data-name": "Path 509926",
    d: "M571.513,249.35h0a1.163,1.163,0,0,0-1.092.746,2.565,2.565,0,0,1-.746,1.192,2.645,2.645,0,0,1-1.99.294c-.5-.242-2.484-2.033-2.85-1.833s-.646.646-.3,1.04,2.185,1.591,1.838,1.99-4.227-1.354-4.821-1.2-.95.518-.6.76,2.983,1.23,3.135,1.582c0,0-3.98-1.045-4.127-.8s-.4.646,0,.8,3.828,1.04,4.127,1.192a7.289,7.289,0,0,0,1.529.446,16.652,16.652,0,0,1,1.605.508,3.486,3.486,0,0,0,2.47-.066l.4-.166a1.567,1.567,0,0,0,.978-1.553L571,252.926l.437-1.116Z",
    transform: "translate(-509.202 -208.256)",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509927",
    "data-name": "Path 509927",
    d: "M597.073,242.527c-.071,0-.123-2.85-.123-6.378s.052-6.378.123-6.378.124,2.85.124,6.378S597.14,242.527,597.073,242.527Z",
    transform: "translate(-528.735 -197.975)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509928",
    "data-name": "Path 509928",
    d: "M548.422,223.78a3.154,3.154,0,0,1,0,.589c0,.427-.029.95-.043,1.6-.052,1.344-.138,3.206-.247,5.258s-.228,3.913-.318,5.257c-.052.632-.1,1.164-.128,1.591a2.424,2.424,0,0,1-.081.584,3.2,3.2,0,0,1,0-.589c0-.427.029-.95.047-1.6.047-1.344.133-3.206.247-5.262s.223-3.913.318-5.257c.048-.632.09-1.164.123-1.591A2.346,2.346,0,0,1,548.422,223.78Z",
    transform: "translate(-502.819 -194.83)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509929",
    "data-name": "Path 509929",
    d: "M572.09,229.633c0,.071-4.982.123-11.132.123s-11.137-.052-11.137-.123,4.987-.123,11.137-.123S572.09,229.567,572.09,229.633Z",
    transform: "translate(-503.989 -197.839)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509930",
    "data-name": "Path 509930",
    d: "M571.8,232.253c0,.066-5.063.123-11.3.123s-11.308-.057-11.308-.123,5.063-.123,11.308-.123S571.8,232.182,571.8,232.253Z",
    transform: "translate(-503.658 -199.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509931",
    "data-name": "Path 509931",
    d: "M572.574,235.6c0,.071-4.987.123-11.137.123s-11.137-.052-11.137-.123,4.987-.124,11.137-.124S572.574,235.537,572.574,235.6Z",
    transform: "translate(-504.241 -200.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509932",
    "data-name": "Path 509932",
    d: "M590.655,256.65a25.237,25.237,0,0,1-1.377,2.7,26.188,26.188,0,0,1-1.468,2.645,14.466,14.466,0,0,1,1.249-2.764A14.771,14.771,0,0,1,590.655,256.65Z",
    transform: "translate(-523.936 -212.089)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509933",
    "data-name": "Path 509933",
    d: "M593.329,257.37a22.9,22.9,0,0,1-3.049,5.291A27.364,27.364,0,0,1,591.767,260a26.645,26.645,0,0,1,1.563-2.626Z",
    transform: "translate(-525.233 -212.467)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509934",
    "data-name": "Path 509934",
    d: "M497.361,223.41a20.141,20.141,0,0,1-2.46,2.341,23.962,23.962,0,0,1-2.641,2.137,23.238,23.238,0,0,1,2.474-2.327c.708-.617,1.354-1.164,1.828-1.553A4.824,4.824,0,0,1,497.361,223.41Z",
    transform: "translate(-473.766 -194.636)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509935",
    "data-name": "Path 509935",
    d: "M499.774,225.24a23.38,23.38,0,0,1-2.493,2.375c-.708.627-1.358,1.187-1.838,1.582a3.849,3.849,0,0,1-.812.6,4.2,4.2,0,0,1,.693-.731c.475-.427,1.083-1.007,1.8-1.634s1.363-1.183,1.843-1.577A4.432,4.432,0,0,1,499.774,225.24Z",
    transform: "translate(-475.011 -195.597)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509936",
    "data-name": "Path 509936",
    d: "M551.053,452.794V448.52l8.045-.1.1,6.283-.475.038c-2.218.152-11.289.608-12.78.176C544.242,454.418,551.053,452.794,551.053,452.794Z",
    transform: "translate(-501.812 -312.781)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633182",
    "data-name": "Group 633182",
    transform: "translate(54.465 139.537)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509937",
    "data-name": "Path 509937",
    d: "M568,458.966a2.806,2.806,0,0,1,1.007-1.724,2.692,2.692,0,0,1,1.876-.608l.029,2.246Z",
    transform: "translate(-568 -456.629)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_633183",
    "data-name": "Group 633183",
    transform: "translate(43.811 140.925)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509938",
    "data-name": "Path 509938",
    d: "M547.672,459.55s-2.375.722-2.08,1.111,9.5.275,13.536-.133v-.18l-10.714.228S548.147,459.564,547.672,459.55Z",
    transform: "translate(-545.567 -459.55)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_509939",
    "data-name": "Path 509939",
    d: "M559.26,461.22h-.138l-.4.028-1.458.081c-1.235.062-2.94.119-4.825.147s-3.6,0-4.83,0l-1.463-.043h6.288c1.885,0,3.591-.076,4.825-.119l1.463-.048h.4A.618.618,0,0,1,559.26,461.22Z",
    transform: "translate(-501.778 -319.502)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509940",
    "data-name": "Path 509940",
    d: "M550.668,460.619a3.5,3.5,0,0,0-.285-.7,3.4,3.4,0,0,0-.5-.551A1.306,1.306,0,0,1,550.668,460.619Z",
    transform: "translate(-504.02 -318.531)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509941",
    "data-name": "Path 509941",
    d: "M556.018,458.644a1.661,1.661,0,0,1-.256-.309c-.119-.185-.2-.342-.176-.356s.138.123.256.3S556.041,458.63,556.018,458.644Z",
    transform: "translate(-507.014 -317.8)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509942",
    "data-name": "Path 509942",
    d: "M557.305,458.143a1.337,1.337,0,0,1-.29-.19c-.142-.123-.237-.237-.218-.256s.142.062.285.185S557.32,458.12,557.305,458.143Z",
    transform: "translate(-507.651 -317.651)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509943",
    "data-name": "Path 509943",
    d: "M557.781,456.944a1,1,0,0,1-.418.057,1.031,1.031,0,0,1-.423-.038.978.978,0,0,1,.418-.062A.907.907,0,0,1,557.781,456.944Z",
    transform: "translate(-507.727 -317.23)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509944",
    "data-name": "Path 509944",
    d: "M557.95,455.89a.827.827,0,0,1-.475.142.807.807,0,0,1-.475-.057,2.581,2.581,0,0,1,.475-.038A2.907,2.907,0,0,1,557.95,455.89Z",
    transform: "translate(-507.759 -316.704)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509945",
    "data-name": "Path 509945",
    d: "M554.23,457.129a1.5,1.5,0,0,1-.518,0,2.848,2.848,0,0,1-.551-.114,1.423,1.423,0,0,1-.318-.123.266.266,0,0,1-.128-.161.2.2,0,0,1,.076-.2.95.95,0,0,1,1.349.6.339.339,0,0,1,0,.138,1.567,1.567,0,0,0-.242-.437.95.95,0,0,0-.446-.28.788.788,0,0,0-.613.052c-.081.062-.047.157.043.209a1.47,1.47,0,0,0,.294.119,3.1,3.1,0,0,0,.532.133C554.03,457.115,554.23,457.11,554.23,457.129Z",
    transform: "translate(-505.506 -316.983)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509946",
    "data-name": "Path 509946",
    d: "M555.547,456.887a.513.513,0,0,1-.066-.361.885.885,0,0,1,.138-.38.513.513,0,0,1,.428-.266.2.2,0,0,1,.161.233.564.564,0,0,1-.086.233,1.676,1.676,0,0,1-.237.318.755.755,0,0,1-.294.214s.1-.1.242-.261a1.715,1.715,0,0,0,.214-.313c.067-.109.114-.309,0-.328s-.261.119-.337.223a.842.842,0,0,0-.142.337A1.572,1.572,0,0,0,555.547,456.887Z",
    transform: "translate(-506.957 -316.698)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509947",
    "data-name": "Path 509947",
    d: "M570.869,456.534s-.233,0-.594.029a2.593,2.593,0,0,0-1.292.551,2.622,2.622,0,0,0-.8,1.154c-.114.347-.124.579-.143.579a.555.555,0,0,1,0-.161,2.372,2.372,0,0,1,.085-.437,2.46,2.46,0,0,1,.8-1.211,2.5,2.5,0,0,1,1.344-.541,1.9,1.9,0,0,1,.442,0A.6.6,0,0,1,570.869,456.534Z",
    transform: "translate(-513.555 -317.015)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509948",
    "data-name": "Path 509948",
    d: "M572.073,449.56a13.937,13.937,0,0,1,.09,1.653,15.08,15.08,0,0,1,0,1.653,13.729,13.729,0,0,1-.09-1.648A13.932,13.932,0,0,1,572.073,449.56Z",
    transform: "translate(-515.66 -313.38)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509949",
    "data-name": "Path 509949",
    d: "M563.221,459.923a4.609,4.609,0,0,1-1.173.133,4.709,4.709,0,0,1-1.178-.081c0-.029.527,0,1.178,0S563.216,459.895,563.221,459.923Z",
    transform: "translate(-509.791 -318.818)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509950",
    "data-name": "Path 509950",
    d: "M568.891,459.877s-.043.114-.1.233-.081.228-.1.228-.043-.123,0-.266S568.872,459.858,568.891,459.877Z",
    transform: "translate(-513.885 -318.795)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509951",
    "data-name": "Path 509951",
    d: "M570.04,458.306a.478.478,0,0,1-.114.19c-.086.086-.161.138-.181.119s.029-.1.114-.19S570.021,458.287,570.04,458.306Z",
    transform: "translate(-514.449 -317.97)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509952",
    "data-name": "Path 509952",
    d: "M571.648,457.528c0,.024-.109.024-.228.071s-.2.1-.223.085.043-.128.19-.18S571.657,457.5,571.648,457.528Z",
    transform: "translate(-515.211 -317.539)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509953",
    "data-name": "Path 509953",
    d: "M573.156,457.2c0,.029-.033.066-.1.1s-.128.028-.138,0,.033-.067.1-.1S573.147,457.175,573.156,457.2Z",
    transform: "translate(-516.117 -317.38)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509954",
    "data-name": "Path 509954",
    d: "M608.47,451.88l.769,3.22s5.267,6.844,6.891,6.507c1.064-.218-.247-2-2.246-7.2l-.423-2.147Z",
    transform: "translate(-534.784 -314.598)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509955",
    "data-name": "Path 509955",
    d: "M617.079,463.3a.722.722,0,0,1-.28.266.979.979,0,0,1-1.012-.138,29.832,29.832,0,0,1-2.622-2.484c-.95-1.026-1.79-2.009-2.375-2.736l-.67-.864-.185-.237-.067-.081s0,.033.052.09l.166.247c.152.214.37.518.651.888a35.3,35.3,0,0,0,2.375,2.759,25.886,25.886,0,0,0,2.655,2.474,1.282,1.282,0,0,0,.594.218.845.845,0,0,0,.475-.1.593.593,0,0,0,.223-.2.283.283,0,0,0,.019-.095Z",
    transform: "translate(-535.519 -317.302)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509956",
    "data-name": "Path 509956",
    d: "M620.981,465.543a.84.84,0,0,0-.432-.052,2.264,2.264,0,0,0-.993.347,1.785,1.785,0,0,0-.722.765.916.916,0,0,0-.114.418,2.446,2.446,0,0,1,.171-.389,1.948,1.948,0,0,1,.712-.712,2.547,2.547,0,0,1,.95-.356A3.919,3.919,0,0,1,620.981,465.543Z",
    transform: "translate(-540.166 -321.74)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509957",
    "data-name": "Path 509957",
    d: "M611.073,458.651a.747.747,0,0,0,.062-.157,2.662,2.662,0,0,0,.1-.442,2.375,2.375,0,0,0-.247-1.463,2.251,2.251,0,0,0-1.064-1.035,1.577,1.577,0,0,0-.432-.133.474.474,0,0,0-.166,0,3.885,3.885,0,0,1,.57.209,2.3,2.3,0,0,1,1.007,1.016,2.459,2.459,0,0,1,.266,1.425A4.263,4.263,0,0,0,611.073,458.651Z",
    transform: "translate(-535.236 -316.454)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509958",
    "data-name": "Path 509958",
    d: "M609.18,453s.095.475.195,1.031a3.566,3.566,0,0,0,.271,1.012c.024,0-.081-.475-.181-1.031A3.414,3.414,0,0,0,609.18,453Z",
    transform: "translate(-535.157 -315.186)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509959",
    "data-name": "Path 509959",
    d: "M618.642,458.106a1.178,1.178,0,0,0-.674,0,1.159,1.159,0,0,0-.608.285c0,.029.276-.114.632-.195S618.642,458.134,618.642,458.106Z",
    transform: "translate(-539.452 -317.841)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509960",
    "data-name": "Path 509960",
    d: "M619.109,459.264a.831.831,0,0,0-.57,0,.788.788,0,0,0-.5.275,2.4,2.4,0,0,1,.522-.185C618.857,459.288,619.1,459.293,619.109,459.264Z",
    transform: "translate(-539.809 -318.449)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509961",
    "data-name": "Path 509961",
    d: "M619.972,460.672a.869.869,0,0,0-1.092.247,2.329,2.329,0,0,1,.522-.233A2.61,2.61,0,0,1,619.972,460.672Z",
    transform: "translate(-540.25 -319.164)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509962",
    "data-name": "Path 509962",
    d: "M617.168,456.182s-.242-.066-.617-.209a4.8,4.8,0,0,1-.637-.309,3.324,3.324,0,0,1-.351-.223c-.1-.076-.223-.195-.219-.318s.157-.195.28-.161a.756.756,0,0,1,.323.214,4.836,4.836,0,0,1,.475.508c.271.3.418.5.432.475a.726.726,0,0,0-.09-.152,4.728,4.728,0,0,0-.29-.385,6.406,6.406,0,0,0-.475-.527.812.812,0,0,0-.366-.242.3.3,0,0,0-.394.247.513.513,0,0,0,.261.4,2.97,2.97,0,0,0,.361.223,3.98,3.98,0,0,0,.655.294,3.63,3.63,0,0,0,.475.128A.687.687,0,0,0,617.168,456.182Z",
    transform: "translate(-538.339 -316.15)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509963",
    "data-name": "Path 509963",
    d: "M618.711,455.624s.033-.228.1-.589a2.59,2.59,0,0,1,.18-.608,1.249,1.249,0,0,1,.195-.309c.081-.09.2-.171.3-.114a.333.333,0,0,1,.1.323,1.375,1.375,0,0,1-.1.351,1.973,1.973,0,0,1-.342.532c-.242.271-.437.4-.423.413a.475.475,0,0,0,.138-.081,2.375,2.375,0,0,0,.333-.285,2.039,2.039,0,0,0,.375-.541,1.315,1.315,0,0,0,.114-.38.394.394,0,0,0-.142-.413.342.342,0,0,0-.413.133,1.275,1.275,0,0,0-.209.337,2.312,2.312,0,0,0-.166.632c0,.185-.029.337-.033.437S618.7,455.624,618.711,455.624Z",
    transform: "translate(-540.157 -315.659)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633184",
    "data-name": "Group 633184",
    transform: "translate(74.085 138.954)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509964",
    "data-name": "Path 509964",
    d: "M609.68,456.948l-.37-1.548s1.287.242,1.624,1.206a4.11,4.11,0,0,1,.252,1.653l2.8,3.021s.708-1.373,1.981-1.045a12.251,12.251,0,0,1,.95,2.759c-.052.551-.674.475-.9.385a11.289,11.289,0,0,1-2.512-1.985A57.834,57.834,0,0,1,609.68,456.948Z",
    transform: "translate(-609.31 -455.4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_509965",
    "data-name": "Path 509965",
    d: "M545.59,284.44l3.833,81.09,10.529.252-.831-70.309,15.749,70.442,8.458-.385-13.55-80.924Z",
    transform: "translate(-501.768 -226.681)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509966",
    "data-name": "Path 509966",
    d: "M568.648,286.75a7.207,7.207,0,0,0,.1,1.335c.085.817.218,1.947.385,3.2a12.752,12.752,0,0,0,.29,1.762,2.484,2.484,0,0,0,.774,1.259,1.934,1.934,0,0,0,.893.442.713.713,0,0,0,.366,0,2.242,2.242,0,0,1-1.833-1.757,15.1,15.1,0,0,1-.271-1.738c-.166-1.249-.323-2.375-.475-3.192A8.064,8.064,0,0,0,568.648,286.75Z",
    transform: "translate(-513.874 -227.894)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509967",
    "data-name": "Path 509967",
    d: "M573.08,287.533c-.029,0,.071.152,0,.366a.432.432,0,0,1-.223.261.346.346,0,0,1-.37-.09.337.337,0,0,1-.1-.361.418.418,0,0,1,.247-.237.5.5,0,0,1,.361,0c.014,0-.109-.19-.4-.133a.542.542,0,1,0,.361,1.016.551.551,0,0,0,.285-.408C573.275,287.647,573.09,287.509,573.08,287.533Z",
    transform: "translate(-515.718 -228.197)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509968",
    "data-name": "Path 509968",
    d: "M587.982,288.226a2.375,2.375,0,0,0-.157-2.246c-.062,0,.1.5.143,1.116S587.9,288.207,587.982,288.226Z",
    transform: "translate(-523.937 -227.489)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509969",
    "data-name": "Path 509969",
    d: "M584.911,287.8a2.009,2.009,0,0,0,.223-1.178,1.982,1.982,0,0,0-.3-1.164,10.08,10.08,0,0,0,.081,1.168A9.064,9.064,0,0,0,584.911,287.8Z",
    transform: "translate(-522.372 -227.216)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509970",
    "data-name": "Path 509970",
    d: "M557.463,287.392a7.343,7.343,0,0,0-.029-1.211,7.158,7.158,0,0,0,0-1.211,2.256,2.256,0,0,0-.209,1.216,2.216,2.216,0,0,0,.237,1.206Z",
    transform: "translate(-507.871 -226.959)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509971",
    "data-name": "Path 509971",
    d: "M553.9,287.019c.062-.024-.114-.56-.133-1.235s.114-1.225.052-1.244a1.961,1.961,0,0,0-.271,1.249,1.99,1.99,0,0,0,.352,1.23Z",
    transform: "translate(-505.938 -226.733)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509972",
    "data-name": "Path 509972",
    d: "M583.78,209.63Z",
    transform: "translate(-521.82 -187.401)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509973",
    "data-name": "Path 509973",
    d: "M482.735,214.159a32.634,32.634,0,0,0-2.4-3.628,22.372,22.372,0,0,0-4.887-1.648c-.347.114-5.224,1.035-4.669,1.61s3.989-.119,3.989-.119l.475.223a21.163,21.163,0,0,0-3.571.893c-.617.37-.361,1.04.18.95a27.926,27.926,0,0,1,3.263-.5c.157.1-2.788.741-3.1.95-.423.256-.475,1.021.086.974.318-.029,3.087-.793,3.087-.793a24.051,24.051,0,0,0-2.375,1.083c-.328.323-.057.8.423.684.328-.076,1.871-.845,2.308-.95,0,0,.413.1.8.95a12.118,12.118,0,0,0,2.436,2.455Z",
    transform: "translate(-462.465 -187.005)",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509974",
    "data-name": "Path 509974",
    d: "M470.83,211.97a2.194,2.194,0,0,0,.9.233,5.34,5.34,0,0,0,1.016.029c.375-.048.784-.114,1.216-.181l.912-.152h-.057a13.615,13.615,0,0,0,2.133.627,12.987,12.987,0,0,0-2.061-.836h-.052l-.907.138-1.2.195a6.4,6.4,0,0,1-.983.024C471.181,212.013,470.84,211.937,470.83,211.97Z",
    transform: "translate(-462.514 -188.482)",
    fill: "#aa6550"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509975",
    "data-name": "Path 509975",
    d: "M458.069,207.36s-3.543,10.748-4.749,12.918l12.063,3.685,2.194-1.4s2.93-8.653,3.3-11.56Z",
    transform: "translate(-453.32 -186.209)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509976",
    "data-name": "Path 509976",
    d: "M479.4,238.53l-.636,1.8,2.194-1.4Z",
    transform: "translate(-466.678 -202.575)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509977",
    "data-name": "Path 509977",
    d: "M473.333,219.538a8.468,8.468,0,0,1-1.349-.423L468.759,218l-3.23-1.059a8.737,8.737,0,0,1-1.33-.475,8.317,8.317,0,0,1,1.382.309c.845.228,2,.575,3.267,1s2.4.85,3.211,1.178A7.127,7.127,0,0,1,473.333,219.538Z",
    transform: "translate(-459.033 -190.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509978",
    "data-name": "Path 509978",
    d: "M471.556,224.8a7.47,7.47,0,0,1-1.325-.3c-.807-.218-1.9-.546-3.135-.95s-2.3-.793-3.082-1.1a7.072,7.072,0,0,1-1.244-.546,7.665,7.665,0,0,1,1.3.38l3.1,1.031,3.106,1.012A7.817,7.817,0,0,1,471.556,224.8Z",
    transform: "translate(-458.282 -193.848)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509979",
    "data-name": "Path 509979",
    d: "M469.816,229.632a38.311,38.311,0,0,1-4.061-1.24,36.212,36.212,0,0,1-3.975-1.472A73.526,73.526,0,0,1,469.816,229.632Z",
    transform: "translate(-457.762 -196.479)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509980",
    "data-name": "Path 509980",
    d: "M487.032,217.894a.974.974,0,0,1-1.14,0,11.409,11.409,0,0,1-.95-.755c-1.007-.684-2.446-.475-3.424-1.23-.133-.1-.271-.271-.2-.427s.257-.161.418-.161l4.047.033",
    transform: "translate(-468.011 -190.388)",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509981",
    "data-name": "Path 509981",
    d: "M485.618,215.271a1.515,1.515,0,0,0-.437-.052l-1.192-.043-1.771-.038H481.7a.8.8,0,0,0-.589.133.337.337,0,0,0-.062.38.622.622,0,0,0,.209.257,2.246,2.246,0,0,0,.513.3,15.275,15.275,0,0,0,2.1.565,3.148,3.148,0,0,1,.841.366c.237.157.437.347.636.5a1.425,1.425,0,0,0,1.145.385c.3-.062.394-.228.385-.228a1.159,1.159,0,0,1-.394.138,1.368,1.368,0,0,1-1.031-.418,7.973,7.973,0,0,0-.651-.556,2.9,2.9,0,0,0-.883-.408,18.621,18.621,0,0,1-2.071-.575,2.345,2.345,0,0,1-.475-.271c-.133-.1-.2-.247-.128-.3a.8.8,0,0,1,.427-.066h2.284c.5,0,.912,0,1.192-.029A1.719,1.719,0,0,0,485.618,215.271Z",
    transform: "translate(-467.865 -190.287)",
    fill: "#aa6550"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-11",
    transform: "translate(116.676 86.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509982",
    "data-name": "Path 509982",
    d: "M286.493,174.911a3.69,3.69,0,0,0-1.51-3.695,3.98,3.98,0,0,0-4.018-.209,4.326,4.326,0,0,0-2.218,3.4,10.073,10.073,0,0,0,1.2,4.578,6.735,6.735,0,0,1,.636,4.631,9.164,9.164,0,0,1-2.375,3.116,6.312,6.312,0,0,0-1.776,3.059,2.894,2.894,0,0,0,1.282,3.092,1.662,1.662,0,0,1,.67.437c.294.418,0,.974-.214,1.425a3.3,3.3,0,0,0-.109,2.227,3.87,3.87,0,0,0,3.9,2.522,5.466,5.466,0,0,0,4.1-2.546,9.432,9.432,0,0,0,1.377-4.749,35.857,35.857,0,0,0-.28-4.992c-.389-4.17,1.558-8.487,1.767-12.671",
    transform: "translate(-267.586 -161.775)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509983",
    "data-name": "Path 509983",
    d: "M301.669,204.586h0a4.179,4.179,0,0,0,4.493-4c.086-2.275.161-4.569.161-4.569a4.1,4.1,0,0,0,3.695-3.733c.252-3.41.133-11.275.133-11.275h0a11.873,11.873,0,0,0-12,.75l.214,12v6.454C298.387,202.387,299.5,204.419,301.669,204.586Z",
    transform: "translate(-279.02 -166.587)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509984",
    "data-name": "Path 509984",
    d: "M304.661,184.973a1.743,1.743,0,0,0-2.332-.508,1.98,1.98,0,0,0-.66,2.474,2.631,2.631,0,0,0,1.672,1.268,1.3,1.3,0,0,1,1.026,1.425,4.388,4.388,0,0,1-1.2,2.375,6.3,6.3,0,0,1-3.942,1.871,4.191,4.191,0,0,1-3.961-1.325,5.371,5.371,0,0,1-.679-3.068l-.161-7.551a10.75,10.75,0,0,1,.171-2.707,3.652,3.652,0,0,1,1.425-2.237,11.534,11.534,0,0,1,2.826-.9,23.359,23.359,0,0,0,3.287-1.729,4.045,4.045,0,0,1,3.567-.347c.8.4,1.33,1.2,2.1,1.634,1.1.627,2.6.475,3.135,2.1a2.773,2.773,0,0,1,0,1.733,4.006,4.006,0,0,1-5.448,2.142A5.393,5.393,0,0,1,305.43,184c-.128.38-.171.95-.76.95",
    transform: "translate(-277.053 -163.44)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509985",
    "data-name": "Path 509985",
    d: "M292.573,196.828a10.235,10.235,0,0,1-.551-14.248",
    transform: "translate(-274.425 -168.086)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509986",
    "data-name": "Path 509986",
    d: "M295.686,198.455a.768.768,0,0,1-.176.052,1.992,1.992,0,0,1-.518,0,2.878,2.878,0,0,1-1.667-.869,8.6,8.6,0,0,1-1.506-2.375,15.167,15.167,0,0,1-1.121-3.23,12.243,12.243,0,0,1-.29-3.41,10.737,10.737,0,0,1,.518-2.745,9.136,9.136,0,0,1,.769-1.719c.114-.195.209-.337.275-.432s.109-.142.114-.138a15.152,15.152,0,0,0-.988,2.341,11.359,11.359,0,0,0-.475,2.7,12.543,12.543,0,0,0,.3,3.325,15.491,15.491,0,0,0,1.088,3.187,8.715,8.715,0,0,0,1.425,2.332,2.9,2.9,0,0,0,1.558.9A4.228,4.228,0,0,0,295.686,198.455Z",
    transform: "translate(-274.945 -168.616)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509987",
    "data-name": "Path 509987",
    d: "M294.1,183.3c.038,0,.3.475.817,1.263a16.575,16.575,0,0,0,2.308,2.774,16.759,16.759,0,0,0,2.85,2.194c.793.475,1.316.727,1.3.765a1.483,1.483,0,0,1-.389-.128q-.51-.212-1-.475a14.134,14.134,0,0,1-2.949-2.17,13.774,13.774,0,0,1-2.284-2.85,9.959,9.959,0,0,1-.527-.978,1.425,1.425,0,0,1-.123-.394Z",
    transform: "translate(-276.893 -168.464)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509988",
    "data-name": "Path 509988",
    d: "M301.573,188.047a4.155,4.155,0,0,1-1.1-.546,12.675,12.675,0,0,1-4.17-4.189,4.273,4.273,0,0,1-.541-1.1,9.655,9.655,0,0,1,.689,1.007,15.6,15.6,0,0,0,4.118,4.137A10.844,10.844,0,0,1,301.573,188.047Z",
    transform: "translate(-277.765 -167.892)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509989",
    "data-name": "Path 509989",
    d: "M306.667,187.364a1.758,1.758,0,0,1-.475-.038,9.381,9.381,0,0,1-1.263-.256,13.241,13.241,0,0,1-6.958-4.669,9.061,9.061,0,0,1-.717-1.069,1.677,1.677,0,0,1-.214-.423c.038,0,.385.556,1.069,1.382a14.831,14.831,0,0,0,3.106,2.807,14.665,14.665,0,0,0,3.771,1.8C306.011,187.217,306.676,187.322,306.667,187.364Z",
    transform: "translate(-278.437 -167.209)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509990",
    "data-name": "Path 509990",
    d: "M284.147,197.847a1.822,1.822,0,0,0,.147-.3,1.5,1.5,0,0,0,.043-.921,2.242,2.242,0,0,0-.817-1.206c-.451-.375-1.054-.67-1.686-1.088a3.8,3.8,0,0,1-.883-.8,2.2,2.2,0,0,1-.451-1.23,4.127,4.127,0,0,1,.993-2.636,14.837,14.837,0,0,0,1.8-2.474,5.566,5.566,0,0,0,.356-3.182,14.723,14.723,0,0,0-.912-3.163,23.838,23.838,0,0,1-.988-2.945,4.98,4.98,0,0,1-.033-2.85,2.061,2.061,0,0,1,.836-1.007,1.544,1.544,0,0,1,1.2-.157,3.7,3.7,0,0,1,1.634,1.206l1,1.145.627.731a2.423,2.423,0,0,1,.2.266,2.553,2.553,0,0,1-.242-.233l-.66-.7-1.026-1.121a3.681,3.681,0,0,0-1.577-1.13,1.377,1.377,0,0,0-1.059.152,1.9,1.9,0,0,0-.746.921,4.726,4.726,0,0,0,.066,2.7,24,24,0,0,0,.993,2.911,14.72,14.72,0,0,1,.95,3.211,5.842,5.842,0,0,1-.385,3.325,14.324,14.324,0,0,1-1.843,2.508,3.961,3.961,0,0,0-.95,2.489,2.018,2.018,0,0,0,.4,1.126,3.656,3.656,0,0,0,.831.774,18.523,18.523,0,0,1,1.672,1.126,2.3,2.3,0,0,1,.822,1.292,1.5,1.5,0,0,1-.085.95A.865.865,0,0,1,284.147,197.847Z",
    transform: "translate(-269.752 -163.491)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509991",
    "data-name": "Path 509991",
    d: "M264.265,447.76l2.313-2.816-5.224-4.374-3.434,4.089.309.29c1.382,1.287,7.124,6.45,8.33,6.962C267.889,452.481,264.265,447.76,264.265,447.76Z",
    transform: "translate(-257.896 -303.548)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633185",
    "data-name": "Group 633185",
    transform: "translate(0.062 139.553)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509992",
    "data-name": "Path 509992",
    d: "M259.9,449a2.375,2.375,0,0,0,.266-1.676,2.332,2.332,0,0,0-.912-1.425L258,447.372Z",
    transform: "translate(-258 -445.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_633186",
    "data-name": "Group 633186",
    transform: "translate(0 141.002)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509993",
    "data-name": "Path 509993",
    d: "M265.944,454.545s1.187,1.753.779,1.847-6.416-4.9-8.853-7.333l.109-.109,6.934,5.884S265.626,454.3,265.944,454.545Z",
    transform: "translate(-257.87 -448.95)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_509994",
    "data-name": "Path 509994",
    d: "M257.93,448.79a.627.627,0,0,0,.081.085l.247.233.921.836c.779.7,1.871,1.653,3.1,2.683s2.375,1.928,3.192,2.574l.988.755.271.2.095.067-.085-.076-.261-.214-.974-.779c-.817-.655-1.943-1.567-3.173-2.593s-2.327-1.971-3.116-2.66l-.95-.817-.256-.218Z",
    transform: "translate(-257.901 -307.864)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509995",
    "data-name": "Path 509995",
    d: "M272.56,461.021a3.155,3.155,0,0,1,.556-.309,2.7,2.7,0,0,1,.632-.09,1.1,1.1,0,0,0-1.187.4Z",
    transform: "translate(-265.583 -314.054)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509996",
    "data-name": "Path 509996",
    d: "M270.68,456.909a.793.793,0,0,0,.332-.066c.176-.057.313-.119.309-.142a.783.783,0,0,0-.332.066C270.832,456.842,270.67,456.885,270.68,456.909Z",
    transform: "translate(-264.596 -312.017)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509997",
    "data-name": "Path 509997",
    d: "M270.18,455.855c0,.024.128.038.285.028s.29-.028.285-.052a.594.594,0,0,0-.285-.029C270.3,455.808,270.18,455.832,270.18,455.855Z",
    transform: "translate(-264.334 -311.543)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509998",
    "data-name": "Path 509998",
    d: "M270.48,454.4a1.526,1.526,0,0,0,.247.266c.152.128.28.218.3.2s-.1-.133-.247-.261A.95.95,0,0,0,270.48,454.4Z",
    transform: "translate(-264.491 -310.81)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509999",
    "data-name": "Path 509999",
    d: "M270.9,453.509a1.026,1.026,0,0,0,.584.565,3.133,3.133,0,0,0-.294-.28C271.033,453.642,270.919,453.495,270.9,453.509Z",
    transform: "translate(-264.712 -310.342)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510000",
    "data-name": "Path 510000",
    d: "M271.828,456.375a1.246,1.246,0,0,0,.337.275,2.528,2.528,0,0,0,.427.223,1.26,1.26,0,0,0,.275.085.252.252,0,0,0,.171-.033.19.19,0,0,0,.062-.181.817.817,0,0,0-1.216-.323.289.289,0,0,0-.085.085,1.269,1.269,0,0,1,.394-.161.835.835,0,0,1,.446.052.688.688,0,0,1,.375.366c.024.081-.052.128-.138.114a1.359,1.359,0,0,1-.261-.076,3.227,3.227,0,0,1-.423-.2C271.966,456.47,271.833,456.36,271.828,456.375Z",
    transform: "translate(-265.184 -311.792)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510001",
    "data-name": "Path 510001",
    d: "M271.889,455.622a.46.46,0,0,0,.233-.2.637.637,0,0,0,.114-.323.428.428,0,0,0-.138-.4.171.171,0,0,0-.233.066.474.474,0,0,0-.066.2,1.393,1.393,0,0,0,0,.337.65.65,0,0,0,.081.294v-.3a1.313,1.313,0,0,1,.029-.318c0-.114.085-.266.185-.209s.1.218.1.328a.712.712,0,0,1-.085.3A1.483,1.483,0,0,1,271.889,455.622Z",
    transform: "translate(-265.178 -310.954)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510002",
    "data-name": "Path 510002",
    d: "M260.67,446a4.619,4.619,0,0,1,.38.337,2.137,2.137,0,0,1,.475,2.242c-.109.29-.228.446-.214.475s.038-.033.09-.1a2.019,2.019,0,0,0,.176-.332,2.061,2.061,0,0,0-.475-2.3,1.858,1.858,0,0,0-.294-.233C260.717,446,260.675,446,260.67,446Z",
    transform: "translate(-259.34 -306.399)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510003",
    "data-name": "Path 510003",
    d: "M263.623,442.32a13.054,13.054,0,0,0-.95,1.04,11.222,11.222,0,0,0-.883,1.092,23.307,23.307,0,0,0,1.824-2.132Z",
    transform: "translate(-259.928 -304.467)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510004",
    "data-name": "Path 510004",
    d: "M264.24,452.509a5.5,5.5,0,0,0,1.52,1.292s-.347-.285-.765-.641S264.259,452.5,264.24,452.509Z",
    transform: "translate(-261.215 -309.817)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510005",
    "data-name": "Path 510005",
    d: "M261.949,450.7c-.024,0-.033.1-.062.2s-.071.195-.052.209.1-.062.128-.185S261.973,450.7,261.949,450.7Z",
    transform: "translate(-259.949 -308.867)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510006",
    "data-name": "Path 510006",
    d: "M262.077,449c-.024,0-.033.081-.028.185s.038.176.057.176.038-.085.028-.185S262.1,449,262.077,449Z",
    transform: "translate(-260.063 -307.975)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510007",
    "data-name": "Path 510007",
    d: "M261.33,447.563s.057.076.114.171.076.176.1.176.038-.109-.029-.218S261.339,447.539,261.33,447.563Z",
    transform: "translate(-259.687 -307.217)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510008",
    "data-name": "Path 510008",
    d: "M260.68,446.657v.114c0,.052.066.09.09.076s0-.062,0-.114S260.7,446.642,260.68,446.657Z",
    transform: "translate(-259.345 -306.743)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510009",
    "data-name": "Path 510009",
    d: "M314.36,454.137l-.081-3.647-6.83.109.062,5.338h.423c1.9.076,9.6.247,10.852-.157C320.2,455.353,314.36,454.137,314.36,454.137Z",
    transform: "translate(-283.903 -308.757)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633187",
    "data-name": "Group 633187",
    transform: "translate(23.599 145.178)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510010",
    "data-name": "Path 510010",
    d: "M310.058,459.651a2.375,2.375,0,0,0-.893-1.425,2.3,2.3,0,0,0-1.605-.475l.029,1.9Z",
    transform: "translate(-307.56 -457.743)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_633188",
    "data-name": "Group 633188",
    transform: "translate(23.609 146.074)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510011",
    "data-name": "Path 510011",
    d: "M317.278,459.63s2.042.556,1.8.893-8.05.475-11.493.214v-.157l9.1-.062S316.893,459.654,317.278,459.63Z",
    transform: "translate(-307.58 -459.63)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_510012",
    "data-name": "Path 510012",
    d: "M307.4,461.42h.456l1.244.038c1.05,0,2.5.029,4.1,0s3.049-.081,4.1-.133l1.24-.071.337-.024a.378.378,0,0,0,.119,0h-.456l-1.24.043c-1.05.038-2.5.081-4.1.1s-3.049,0-4.1,0h-1.7Z",
    transform: "translate(-283.877 -314.396)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510013",
    "data-name": "Path 510013",
    d: "M326.787,460.543a2.547,2.547,0,0,1,.223-.6,2.676,2.676,0,0,1,.413-.475,1.1,1.1,0,0,0-.636,1.078Z",
    transform: "translate(-294.055 -313.472)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510014",
    "data-name": "Path 510014",
    d: "M322.506,459a1.449,1.449,0,0,0,.209-.266c.095-.157.161-.294.142-.309s-.114.1-.209.266S322.487,458.989,322.506,459Z",
    transform: "translate(-291.807 -312.925)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510015",
    "data-name": "Path 510015",
    d: "M321.337,458.566a1.091,1.091,0,0,0,.237-.166c.119-.109.195-.2.181-.223s-.123.057-.237.166S321.318,458.566,321.337,458.566Z",
    transform: "translate(-291.193 -312.791)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510016",
    "data-name": "Path 510016",
    d: "M320.58,457.49a.768.768,0,0,0,.356.043.18.18,0,1,0,0-.085A.951.951,0,0,0,320.58,457.49Z",
    transform: "translate(-290.797 -312.338)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510017",
    "data-name": "Path 510017",
    d: "M320.31,456.74a.7.7,0,0,0,.4.109.665.665,0,0,0,.408-.062,2.263,2.263,0,0,0-.4,0A2,2,0,0,0,320.31,456.74Z",
    transform: "translate(-290.655 -312.039)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510018",
    "data-name": "Path 510018",
    d: "M323,457.7a1.365,1.365,0,0,0,.437,0,2.273,2.273,0,0,0,.475-.114.978.978,0,0,0,.266-.114.252.252,0,0,0,.109-.138.166.166,0,0,0-.071-.171.8.8,0,0,0-.993.247.893.893,0,0,0-.138.3.288.288,0,0,0,0,.119,1.224,1.224,0,0,1,.195-.38.76.76,0,0,1,.37-.247.665.665,0,0,1,.522.024c.071.052.047.133-.029.181a1.15,1.15,0,0,1-.247.109,3.2,3.2,0,0,1-.451.128A3.924,3.924,0,0,0,323,457.7Z",
    transform: "translate(-292.068 -312.219)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510019",
    "data-name": "Path 510019",
    d: "M322.575,457.485a.475.475,0,0,0,.043-.3.689.689,0,0,0-.124-.323.441.441,0,0,0-.366-.218.176.176,0,0,0-.133.209.475.475,0,0,0,.076.195,1.236,1.236,0,0,0,.214.261c.138.133.247.181.252.171s-.09-.076-.214-.214a1.19,1.19,0,0,1-.185-.261c-.062-.09-.1-.256,0-.275s.223.1.29.181a.717.717,0,0,1,.128.285,1.52,1.52,0,0,1,.019.294Z",
    transform: "translate(-291.538 -311.986)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510020",
    "data-name": "Path 510020",
    d: "M307.64,457.632a2.808,2.808,0,0,1,.5,0,2.137,2.137,0,0,1,1.809,1.425c.109.29.123.475.138.475a.35.35,0,0,0,0-.138,1.964,1.964,0,0,0-.081-.37,2.142,2.142,0,0,0-.708-1.007,2.119,2.119,0,0,0-1.154-.427,1.733,1.733,0,0,0-.375,0C307.682,457.612,307.635,457.627,307.64,457.632Z",
    transform: "translate(-284.002 -312.479)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510021",
    "data-name": "Path 510021",
    d: "M308.956,451.68a12.958,12.958,0,0,0-.033,1.425,11.475,11.475,0,0,0,.043,1.4,12.141,12.141,0,0,0,.038-1.4A10.925,10.925,0,0,0,308.956,451.68Z",
    transform: "translate(-284.673 -309.382)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510022",
    "data-name": "Path 510022",
    d: "M314.61,460.3a4.276,4.276,0,0,0,1,.085,3.8,3.8,0,0,0,1-.1c0-.024-.451,0-1,0A8.744,8.744,0,0,0,314.61,460.3Z",
    transform: "translate(-287.662 -313.896)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510023",
    "data-name": "Path 510023",
    d: "M311.79,460.366s.038.1.086.195.076.19.1.19.033-.109-.024-.223S311.8,460.347,311.79,460.366Z",
    transform: "translate(-286.182 -313.941)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510024",
    "data-name": "Path 510024",
    d: "M310.71,459.052a.409.409,0,0,0,.1.157c.071.066.142.119.161.1s-.029-.085-.1-.157S310.724,459.023,310.71,459.052Z",
    transform: "translate(-285.615 -313.248)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510025",
    "data-name": "Path 510025",
    d: "M309.18,458.435a.459.459,0,0,1,.2.057c.1.057.171.085.19.071s-.043-.109-.166-.152S309.175,458.416,309.18,458.435Z",
    transform: "translate(-284.811 -312.907)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510026",
    "data-name": "Path 510026",
    d: "M308.09,458.195c0,.024.033.057.09.081a.185.185,0,0,0,.119,0c.01,0-.033-.052-.09-.076S308.1,458.176,308.09,458.195Z",
    transform: "translate(-284.239 -312.795)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510027",
    "data-name": "Path 510027",
    d: "M279.089,294.533s-2.275,9.622-1.629,11.527,4.806,3.006,4.806,3.006l-.138,26.354-23.048,28.5,8.511,6.967s24.948-28.543,27.147-33.72-1.425-43.053-1.425-43.053Z",
    transform: "translate(-258.505 -226.647)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510028",
    "data-name": "Path 510028",
    d: "M303.375,286l1.13,80.04-11.726.057-7.6-63.9h0c-1.159-3.8-2.479-7.765-2.242-12.3l1.572-4.6Z",
    transform: "translate(-271.018 -222.021)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510029",
    "data-name": "Path 510029",
    d: "M297.37,312.51a2.375,2.375,0,0,1,.275.237c.166.166.418.413.722.746.617.665,1.482,1.658,2.512,2.94h0v.029c.214,3.586.636,8.815,1.145,14.623.4,4.749.822,9.052,1.078,12.419v.033l-.024.029-3.263,4.369-.9,1.187-.242.309-.09.1s0-.043.066-.119l.219-.323.864-1.221,3.2-4.417v.057c-.309-3.362-.7-7.689-1.135-12.405-.508-5.809-.9-11.042-1.064-14.633v.048c-1.012-1.292-1.857-2.3-2.451-2.983-.294-.342-.532-.6-.689-.774A1.709,1.709,0,0,1,297.37,312.51Z",
    transform: "translate(-278.61 -236.308)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510030",
    "data-name": "Path 510030",
    d: "M317.351,377.208a11.565,11.565,0,0,0-3.168-.826,12.036,12.036,0,0,0-3.253.313,2.642,2.642,0,0,1,.912-.356,7.2,7.2,0,0,1,4.664.37A2.526,2.526,0,0,1,317.351,377.208Z",
    transform: "translate(-285.73 -269.703)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510031",
    "data-name": "Path 510031",
    d: "M316.656,386.22c.052.043-3.244,4.469-7.366,9.888s-7.509,9.779-7.561,9.736,3.239-4.469,7.366-9.888S316.58,386.182,316.656,386.22Z",
    transform: "translate(-280.899 -275.011)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510032",
    "data-name": "Path 510032",
    d: "M325.458,298.6a2.018,2.018,0,0,1-.66.869,3.268,3.268,0,0,1-4.783-.5,1.938,1.938,0,0,1-.475-.988,10.285,10.285,0,0,0,.6.879,3.258,3.258,0,0,0,4.531.475C325.182,298.939,325.4,298.574,325.458,298.6Z",
    transform: "translate(-290.251 -228.679)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510033",
    "data-name": "Path 510033",
    d: "M277.885,250.559s-1.781,13.023,0,14.671a3.73,3.73,0,0,0,3.486,1.107l3.386-2.85.665-12.947Z",
    transform: "translate(-267.964 -203.77)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510034",
    "data-name": "Path 510034",
    d: "M278.823,228.3s-2.546,2.878-3.073,13.882c0,0,7.252,1.377,7.385.978S278.823,228.3,278.823,228.3Z",
    transform: "translate(-267.258 -192.092)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510035",
    "data-name": "Path 510035",
    d: "M281.672,256.061l23.105.375-.356-3.477s-2.546-13.236-2.527-13.407l.4-.845a7.689,7.689,0,0,0,.195-6.687h11.218l-.475-9.1-11.774-1.733-4.379-.347s-7.718.4-7.884.423c-3.23.389-6.986.636-8.359,4.094-.736,1.847-.038,4.621,1.159,7.485l2.85,8.781c1.14,4.83-.679,4.6-1.677,9.461C283.026,251.815,281.658,255.382,281.672,256.061Z",
    transform: "translate(-269.771 -188.175)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510036",
    "data-name": "Path 510036",
    d: "M314.026,225.938c0,.066-6.587.124-14.723.124s-14.723-.057-14.723-.124,6.583-.128,14.723-.128S314.026,225.867,314.026,225.938Z",
    transform: "translate(-271.895 -190.785)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510037",
    "data-name": "Path 510037",
    d: "M311.823,235.143c0,.071-7.323.124-16.361.124s-16.361-.052-16.361-.124,7.323-.123,16.361-.123S311.823,235.077,311.823,235.143Z",
    transform: "translate(-269.017 -195.621)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510038",
    "data-name": "Path 510038",
    d: "M279.916,245.624a7.6,7.6,0,0,1-2.726,0A7.6,7.6,0,0,1,279.916,245.624Z",
    transform: "translate(-268.014 -201.124)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510039",
    "data-name": "Path 510039",
    d: "M304.335,245.943c0,.066-4.792.123-10.7.123s-10.7-.057-10.7-.123,4.792-.123,10.7-.123S304.335,245.877,304.335,245.943Z",
    transform: "translate(-271.028 -201.291)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510040",
    "data-name": "Path 510040",
    d: "M305.761,256.743c0,.066-4.3.123-9.608.123s-9.6-.057-9.6-.123,4.3-.124,9.6-.124S305.761,256.672,305.761,256.743Z",
    transform: "translate(-272.929 -206.962)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510041",
    "data-name": "Path 510041",
    d: "M307.461,266.743c0,.066-3.9.123-8.706.123s-8.706-.057-8.706-.123,3.9-.124,8.706-.124S307.461,266.677,307.461,266.743Z",
    transform: "translate(-274.767 -212.213)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510042",
    "data-name": "Path 510042",
    d: "M307.727,274.863c0,.066-4.17.123-9.313.123s-9.313-.057-9.313-.123,4.17-.124,9.313-.124S307.727,274.783,307.727,274.863Z",
    transform: "translate(-274.268 -216.476)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510043",
    "data-name": "Path 510043",
    d: "M307.431,285.163c0,.066-4.749.123-10.6.123s-10.6-.057-10.6-.123,4.749-.123,10.6-.123S307.431,285.092,307.431,285.163Z",
    transform: "translate(-272.766 -221.884)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510044",
    "data-name": "Path 510044",
    d: "M285,251.013a1.9,1.9,0,0,1-.195-.437c-.133-.342-.285-.746-.475-1.216-.389-1.031-.95-2.446-1.515-4.023s-1.05-3.025-1.349-4.089c-.152-.527-.261-.95-.328-1.263a2.109,2.109,0,0,1-.076-.475,17.149,17.149,0,0,1,.57,1.691c.342,1.04.841,2.474,1.425,4.051s1.1,3,1.449,4.046c.176.522.309.95.394,1.244A1.567,1.567,0,0,1,285,251.013Z",
    transform: "translate(-270.046 -197.978)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633189",
    "data-name": "Group 633189",
    transform: "translate(15.911 51.409)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510045",
    "data-name": "Path 510045",
    d: "M292.093,270.61a22.842,22.842,0,0,0,6.008-3.391,10.923,10.923,0,0,0,3.762-5.675c.1-.423.114-.978-.271-1.183a.746.746,0,0,0-.85.214,3,3,0,0,0-.475.817,5.917,5.917,0,0,1-2.047,2.417,16.875,16.875,0,0,1-3.358,1.487,6.176,6.176,0,0,0-2.973,2.071,2.681,2.681,0,0,0,.157,3.372",
    transform: "translate(-291.371 -260.307)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_510046",
    "data-name": "Path 510046",
    d: "M303.034,254.34v.722a12.688,12.688,0,0,1-.285,1.942,13.839,13.839,0,0,1-7.984,9.66,12.577,12.577,0,0,1-1.852.646c-.223.062-.4.1-.518.119a.694.694,0,0,1-.185.024,4.108,4.108,0,0,1,.674-.233,15.576,15.576,0,0,0,1.809-.717,14.248,14.248,0,0,0,7.884-9.541,16.149,16.149,0,0,0,.361-1.9A5.225,5.225,0,0,1,303.034,254.34Z",
    transform: "translate(-275.901 -205.765)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510047",
    "data-name": "Path 510047",
    d: "M349.735,164.58s-.052-.294-.1-.874a9.293,9.293,0,0,1,.2-2.569,10.648,10.648,0,0,1,6.079-7.423,11.7,11.7,0,0,1,3.291-.907,12.718,12.718,0,0,1,3.761.081,13.773,13.773,0,0,1,7.447,3.951,16.437,16.437,0,0,1,2.85,3.8,15.079,15.079,0,0,1,1.6,4.8,14.247,14.247,0,0,1-.157,5.348,12.029,12.029,0,0,1-.921,2.641,10.707,10.707,0,0,1-1.615,2.375,10.923,10.923,0,0,1-5.03,3.059,18.565,18.565,0,0,1-6.15.632,24.393,24.393,0,0,1-6.34-1.13,10.976,10.976,0,0,1-5.452-3.8,11.313,11.313,0,0,1-2.1-6.535,12.567,12.567,0,0,1,.475-3.524,14.627,14.627,0,0,1,1.477-3.3,16.1,16.1,0,0,1,2.313-2.85,15.751,15.751,0,0,1,3-2.2,13.915,13.915,0,0,1,3.534-1.311,12.785,12.785,0,0,1,3.8-.2,15.069,15.069,0,0,1,12.125,8.914,13.018,13.018,0,0,1,.708,7.988,10.387,10.387,0,0,1-1.71,3.752,9.219,9.219,0,0,1-3.173,2.683,11.436,11.436,0,0,1-4.023,1.183,14.385,14.385,0,0,1-4.232-.176,14.675,14.675,0,0,1-7.509-3.918,11.964,11.964,0,0,1-2.5-3.534,9.242,9.242,0,0,1-.826-4.274,11.532,11.532,0,0,1,3.918-7.7,13.887,13.887,0,0,1,7.936-3.552,11.875,11.875,0,0,1,8.221,2.284,10.747,10.747,0,0,1,2.85,3.2,9.318,9.318,0,0,1,.869,1.966c.123.337.19.689.28,1.035a5.7,5.7,0,0,1,.157,1.059,11.484,11.484,0,0,1-2.2,7.988,12.42,12.42,0,0,1-6.825,4.483,13.379,13.379,0,0,1-8.017-.394,15.205,15.205,0,0,1-9.8-11.441,11.038,11.038,0,0,1,1.278-7.361,12.852,12.852,0,0,1,5.267-5.058,15.673,15.673,0,0,1,6.91-1.71,18.048,18.048,0,0,1,6.806,1.183,15.9,15.9,0,0,1,9.3,8.819,13.512,13.512,0,0,1-1,11.721,11,11,0,0,1-4.051,3.894,13.346,13.346,0,0,1-5.106,1.591,17.368,17.368,0,0,1-9.5-1.933,21.092,21.092,0,0,1-6.73-5.191A13.593,13.593,0,0,1,348,165.806a10.477,10.477,0,0,1,.636-5.642,9.414,9.414,0,0,1,2.375-3.443,7.837,7.837,0,0,1,2.166-1.392c.546-.195.831-.28.831-.28l-.209.076c-.138.052-.347.123-.613.228a8.027,8.027,0,0,0-2.142,1.425,9.418,9.418,0,0,0-2.327,3.434,10.448,10.448,0,0,0-.622,5.595,13.5,13.5,0,0,0,3.116,6.336,21.044,21.044,0,0,0,6.7,5.144,17.25,17.25,0,0,0,9.442,1.9,13.26,13.26,0,0,0,5.039-1.577,10.8,10.8,0,0,0,3.98-3.847,13.336,13.336,0,0,0,.978-11.56,15.733,15.733,0,0,0-9.195-8.7,17.839,17.839,0,0,0-6.73-1.159,15.421,15.421,0,0,0-6.815,1.686,12.69,12.69,0,0,0-5.186,4.958,10.814,10.814,0,0,0-1.249,7.214,14.974,14.974,0,0,0,9.66,11.256,13.113,13.113,0,0,0,7.879.385,12.154,12.154,0,0,0,6.687-4.4,11.242,11.242,0,0,0,2.194-7.817c-.024-.347-.1-.689-.157-1.035a10.317,10.317,0,0,0-1.116-2.926,10.639,10.639,0,0,0-2.807-3.13,11.493,11.493,0,0,0-8.074-2.232,13.64,13.64,0,0,0-7.794,3.467,11.27,11.27,0,0,0-3.837,7.528,9.023,9.023,0,0,0,.8,4.165,11.817,11.817,0,0,0,2.446,3.458,14.433,14.433,0,0,0,7.385,3.852,14.2,14.2,0,0,0,4.156.176,11,11,0,0,0,3.937-1.159,8.9,8.9,0,0,0,3.092-2.612,10.082,10.082,0,0,0,1.672-3.657,12.823,12.823,0,0,0-.693-7.846,14.851,14.851,0,0,0-11.93-8.8,12.823,12.823,0,0,0-3.742.195,13.72,13.72,0,0,0-3.467,1.292,15.256,15.256,0,0,0-2.954,2.156,15.491,15.491,0,0,0-2.28,2.8,14.355,14.355,0,0,0-1.458,3.239,12.458,12.458,0,0,0-.475,3.462,11.108,11.108,0,0,0,2.056,6.412,10.733,10.733,0,0,0,5.343,3.714,24.373,24.373,0,0,0,6.283,1.145,18.281,18.281,0,0,0,6.089-.617,10.187,10.187,0,0,0,6.545-5.333,11.876,11.876,0,0,0,.912-2.6,14.2,14.2,0,0,0,.166-5.286,15.474,15.474,0,0,0-4.379-8.549,13.678,13.678,0,0,0-7.371-3.928,12.506,12.506,0,0,0-3.728-.085,11.569,11.569,0,0,0-3.268.888,10.448,10.448,0,0,0-4.369,3.552,10.594,10.594,0,0,0-1.7,3.8,9.633,9.633,0,0,0-.223,2.56,6.428,6.428,0,0,0,.057.655C349.726,164.5,349.735,164.58,349.735,164.58Z",
    transform: "translate(-304.721 -152.062)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510048",
    "data-name": "Path 510048",
    d: "M376.552,173.236c0,.062-3.092,1.1-6.948,2.308s-7.005,2.142-7.024,2.075,3.092-1.1,6.948-2.308S376.51,173.17,376.552,173.236Z",
    transform: "translate(-312.85 -163.178)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510049",
    "data-name": "Path 510049",
    d: "M379.4,178c.024.062-2.878,1.121-6.478,2.375s-6.53,2.189-6.554,2.123,2.878-1.121,6.478-2.375S379.378,177.925,379.4,178Z",
    transform: "translate(-314.84 -165.677)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510050",
    "data-name": "Path 510050",
    d: "M375.306,187.759a15.141,15.141,0,0,1-3.239,1.344c-.912.323-1.748.6-2.375.788a4.162,4.162,0,0,1-1,.256,4.421,4.421,0,0,1,.95-.423c.594-.228,1.425-.532,2.332-.855s1.748-.608,2.351-.807S375.33,187.75,375.306,187.759Z",
    transform: "translate(-316.058 -170.805)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510051",
    "data-name": "Path 510051",
    d: "M385.7,191.773s-2.175-1.007-2.28-.475.043.746.475.879,1.61.532,1.61.532Z",
    transform: "translate(-323.778 -172.582)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510052",
    "data-name": "Path 510052",
    d: "M385.444,193.863s-2.175-1.007-2.28-.475.038.741.475.879,1.61.532,1.61.532Z",
    transform: "translate(-323.641 -173.68)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510053",
    "data-name": "Path 510053",
    d: "M362.8,195.471l-8.254,10.809a5.818,5.818,0,0,1-4.241,2.645l-.774.066.385,7.366,3.258-.37a6.554,6.554,0,0,0,4.925-3.22l8.392-14.5a24.946,24.946,0,0,0,1.472-2.9,6.177,6.177,0,0,0-.038-3.13l-3.325,2.1V192.07s-.356-.123-1.05.556C362.952,193.229,362.8,195.471,362.8,195.471Z",
    transform: "translate(-305.998 -173.064)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510054",
    "data-name": "Path 510054",
    d: "M381.15,188.579l.043,7.974a.646.646,0,0,0,.689.641h0a.646.646,0,0,0,.6-.646v-8.074l-.76-1.235Z",
    transform: "translate(-322.6 -170.533)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510055",
    "data-name": "Path 510055",
    d: "M382.1,187.29l-.209.48.489-.024Z",
    transform: "translate(-322.989 -170.559)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510056",
    "data-name": "Path 510056",
    d: "M382.444,189.875a1.064,1.064,0,0,1-.66.209,1.216,1.216,0,0,1-.684-.119c0-.033.309.043.679.024S382.43,189.847,382.444,189.875Z",
    transform: "translate(-322.574 -171.914)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510057",
    "data-name": "Path 510057",
    d: "M382.436,198.744a1.98,1.98,0,0,1-.024-.337c0-.275,0-.579,0-.917,0-.86,0-1.9-.024-3.025s0-2.161,0-3.021v-.917a1.706,1.706,0,0,1,0-.337,2.373,2.373,0,0,1,0,.337v7.879A3.252,3.252,0,0,1,382.436,198.744Z",
    transform: "translate(-323.245 -172.082)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-11",
    transform: "translate(59.444 162.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510058",
    "data-name": "Path 510058",
    d: "M148,367.4c3.714,1.3,8.549.138,11.745-2.185s5.466-5.647,7.494-9.024a13.325,13.325,0,0,0,1.985-4.6,4.961,4.961,0,0,0-1.425-4.607c-2-1.681-5.063-.826-7.328.475A25.276,25.276,0,0,0,148,367.4",
    transform: "translate(-114.781 -329.288)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510059",
    "data-name": "Path 510059",
    d: "M156.38,403.178c2.232,2.945,6.065,4.274,9.76,4.426a27.237,27.237,0,0,0,10.786-2.17c1.254-.475,2.622-1.14,3.054-2.408a3.068,3.068,0,0,0-.655-2.85,6.321,6.321,0,0,0-2.489-1.7,17.014,17.014,0,0,0-10.862-.589,26.668,26.668,0,0,0-9.594,5.281",
    transform: "translate(-119.181 -356.184)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510060",
    "data-name": "Path 510060",
    d: "M146.136,332.926c3.078.062,5.4-2.631,6.8-5.376a19.947,19.947,0,0,0,1.814-12.405c-.285-1.572-.879-3.268-2.284-4.027a4.075,4.075,0,0,0-4.488.836,9.261,9.261,0,0,0-2.337,4.208,28.1,28.1,0,0,0,.475,16.789",
    transform: "translate(-112.983 -310.752)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510061",
    "data-name": "Path 510061",
    d: "M121.059,356.483a37.109,37.109,0,0,0,3.021-29.736c-.5-1.605-1.449-3.438-3.125-3.543-1.857-.119-3.021,1.952-3.533,3.738-1.8,6.279-1.425,12.942-1.021,19.472a13.82,13.82,0,0,0,4.659,10.083",
    transform: "translate(-98.013 -317.288)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510062",
    "data-name": "Path 510062",
    d: "M95.644,385.548a21.448,21.448,0,0,0-12.728-13.5c-1.4-.522-3.163-.822-4.2.242s-.684,2.812-.052,4.1a20.513,20.513,0,0,0,4.479,5.428,18.454,18.454,0,0,0,5.134,3.823c1.966.86,5.576,1.078,7.371-.09",
    transform: "translate(-78.054 -342.687)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510063",
    "data-name": "Path 510063",
    d: "M156.881,352.709a.419.419,0,0,1-.09.081l-.285.218-1.1.822-.793.589c-.29.223-.589.475-.917.746-.651.541-1.425,1.126-2.189,1.862l-1.235,1.126c-.432.394-.841.836-1.287,1.278-.9.864-1.776,1.9-2.717,2.926a57.862,57.862,0,0,0-9.608,15.511c-.518,1.311-1.031,2.546-1.425,3.742-.195.594-.408,1.164-.565,1.719s-.309,1.1-.475,1.61c-.309,1.021-.475,1.966-.684,2.788-.09.413-.185.8-.256,1.154l-.171.974q-.157.86-.242,1.354l-.071.351a.586.586,0,0,1-.033.119.476.476,0,0,1,0-.124,3.357,3.357,0,0,1,.043-.356c.048-.328.114-.784.2-1.358.043-.294.095-.627.147-.983s.157-.741.237-1.159c.185-.826.351-1.781.655-2.807l.437-1.615c.157-.565.366-1.135.556-1.733.366-1.2.879-2.446,1.387-3.761a62.726,62.726,0,0,1,4.179-8.183,61.984,61.984,0,0,1,5.447-7.39c.95-1.05,1.833-2.061,2.745-2.926.475-.437.869-.879,1.3-1.268l1.254-1.116c.779-.731,1.558-1.306,2.218-1.843.332-.261.636-.513.926-.727l.812-.575,1.13-.784.3-.2C156.843,352.728,156.876,352.7,156.881,352.709Z",
    transform: "translate(-106.764 -332.782)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510064",
    "data-name": "Path 510064",
    d: "M164.154,403.743a1.659,1.659,0,0,1-.361-.057c-.237-.043-.575-.133-1.021-.209A28.178,28.178,0,0,0,134.134,415.4c-.261.37-.437.674-.57.869a1.9,1.9,0,0,1-.214.3,2.5,2.5,0,0,1,.171-.323c.119-.2.285-.518.532-.9a25.592,25.592,0,0,1,2.3-3.082A27.252,27.252,0,0,1,159,402.841a25.114,25.114,0,0,1,3.8.541c.442.09.784.195,1.012.252a3.385,3.385,0,0,1,.347.109Z",
    transform: "translate(-107.088 -359.067)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510065",
    "data-name": "Path 510065",
    d: "M144.536,319a.751.751,0,0,1,0,.138c-.024.1-.052.237-.085.4-.081.366-.2.883-.342,1.534-.3,1.335-.765,3.258-1.344,5.637-1.154,4.749-2.85,11.3-4.583,18.551-.874,3.628-1.658,7.1-2.337,10.254s-1.235,6.017-1.658,8.425c-.223,1.2-.394,2.294-.556,3.253s-.294,1.781-.394,2.46-.18,1.183-.237,1.553l-.071.408a.588.588,0,0,1-.033.133.6.6,0,0,1,0-.138c0-.1.024-.242.043-.408.048-.375.114-.9.195-1.562s.2-1.51.351-2.47.309-2.052.522-3.258c.4-2.413.95-5.276,1.605-8.444s1.449-6.649,2.318-10.263c1.748-7.257,3.458-13.8,4.654-18.522.6-2.375,1.078-4.274,1.425-5.618.166-.646.294-1.159.389-1.525.043-.161.081-.29.109-.394A.518.518,0,0,1,144.536,319Z",
    transform: "translate(-106.848 -315.083)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510066",
    "data-name": "Path 510066",
    d: "M128.034,380.659a.321.321,0,0,0-.033-.109,2.045,2.045,0,0,1-.076-.323q-.09-.475-.256-1.24c-.223-1.083-.518-2.65-.855-4.593-.674-3.885-1.468-9.28-1.961-15.279-.237-3-.37-5.865-.427-8.473s0-4.958.062-6.929c0-.983.09-1.876.133-2.66s.095-1.453.142-2,.09-.95.119-1.268l.038-.328a.423.423,0,0,1,0-.109.413.413,0,0,1,0,.114v.328c0,.313-.038.736-.066,1.268s-.076,1.221-.1,2-.085,1.672-.095,2.655c-.062,1.971-.066,4.317,0,6.92s.209,5.462.446,8.459c.475,5.989,1.259,11.4,1.9,15.269.318,1.947.584,3.519.779,4.6.085.527.157.95.209,1.254l.052.323A1.034,1.034,0,0,1,128.034,380.659Z",
    transform: "translate(-102.389 -324.718)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510067",
    "data-name": "Path 510067",
    d: "M109.458,403.815a3.062,3.062,0,0,1-.138-.309l-.342-.9-.247-.651c-.1-.233-.218-.475-.337-.755s-.252-.56-.385-.864-.313-.617-.475-.95l-.532-1.04c-.209-.351-.418-.717-.641-1.1-.418-.769-.95-1.534-1.491-2.375a55.576,55.576,0,0,0-3.951-5.053,61.857,61.857,0,0,0-4.536-4.536c-.75-.636-1.425-1.273-2.142-1.81l-.993-.788-.95-.7c-.6-.451-1.154-.826-1.648-1.159s-.917-.617-1.273-.831l-.812-.518a1.425,1.425,0,0,1-.275-.195,2.51,2.51,0,0,1,.3.152l.841.475c.366.2.8.475,1.3.8s1.069.689,1.672,1.135l.95.684,1.007.784c.708.527,1.425,1.159,2.166,1.8a58.669,58.669,0,0,1,4.569,4.545,53.071,53.071,0,0,1,3.956,5.087c.522.841,1.064,1.615,1.482,2.375q.318.579.627,1.111l.522,1.054c.161.337.332.651.475.95s.252.6.37.879l.318.765c.081.237.157.475.228.66l.3.917A1.577,1.577,0,0,1,109.458,403.815Z",
    transform: "translate(-83.429 -346.739)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510068",
    "data-name": "Path 510068",
    d: "M167.256,374.415a15.4,15.4,0,0,1-1.658.1,31.057,31.057,0,0,0-3.961.475,31.456,31.456,0,0,0-3.861,1,16.194,16.194,0,0,1-1.577.522,1.425,1.425,0,0,1,.394-.214c.261-.128.646-.29,1.126-.475a24.142,24.142,0,0,1,3.875-1.088,23.563,23.563,0,0,1,4-.408h1.216A1.794,1.794,0,0,1,167.256,374.415Z",
    transform: "translate(-119.086 -344.135)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510069",
    "data-name": "Path 510069",
    d: "M182.008,408.972a11.992,11.992,0,0,0-5.248-5.652,3.482,3.482,0,0,1,1.069.475,9.4,9.4,0,0,1,3.8,4.08A3.514,3.514,0,0,1,182.008,408.972Z",
    transform: "translate(-129.881 -359.356)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510070",
    "data-name": "Path 510070",
    d: "M155.157,334.24c.047.052-.917,1.012-1.971,2.308s-1.8,2.432-1.866,2.375a10.924,10.924,0,0,1,1.677-2.55A10.672,10.672,0,0,1,155.157,334.24Z",
    transform: "translate(-116.524 -323.085)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510071",
    "data-name": "Path 510071",
    d: "M152.715,322.72a8.688,8.688,0,0,1,.475,2.071,9.022,9.022,0,0,1,.233,2.109,18.747,18.747,0,0,1-.712-4.179Z",
    transform: "translate(-117.254 -317.036)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510072",
    "data-name": "Path 510072",
    d: "M128.421,358.88a25.613,25.613,0,0,1-1.534,3.234,25.874,25.874,0,0,1-1.757,3.116,26.119,26.119,0,0,1,1.534-3.23A26.667,26.667,0,0,1,128.421,358.88Z",
    transform: "translate(-102.772 -336.022)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510073",
    "data-name": "Path 510073",
    d: "M119.76,346.61a28.77,28.77,0,0,1,2.379,4.783,15.049,15.049,0,0,1-1.3-2.337,14.647,14.647,0,0,1-1.078-2.446Z",
    transform: "translate(-99.953 -329.58)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510074",
    "data-name": "Path 510074",
    d: "M96.429,388.028c0,.071-1.054-.133-2.375-.223s-2.375-.038-2.375-.114a9.57,9.57,0,0,1,4.749.337Z",
    transform: "translate(-85.209 -351.055)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510075",
    "data-name": "Path 510075",
    d: "M114,425.73l2.921,15.359a2.147,2.147,0,0,0,2.113,1.748h8.644a2.147,2.147,0,0,0,2.123-1.8l2.541-15.307Z",
    transform: "translate(-96.928 -371.123)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510076",
    "data-name": "Path 510076",
    d: "M114.98,430.721h16.5l.879-4.991H114.03Z",
    transform: "translate(-96.944 -371.123)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510077",
    "data-name": "Path 510077",
    d: "M116.03,436.24l.347,1.819h15.9l.252-1.819Z",
    transform: "translate(-97.994 -376.642)",
    fill: "#fafafa"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyEvents);
export default __webpack_public_path__ + "static/media/EmptyEvents.4406341ded6fb852097ee9cd2e40a27d.svg";
export { ForwardRef as ReactComponent };